
/**
 * <auto-generated>
 *     This code was generated by a tool.
 *
 *     Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
 * </auto-generated>
 */

// @ts-ignore 
import { Field, ImageField, FileField, LinkField, Item, TextField } from '@sitecore-content-sdk/nextjs';
// @ts-ignore 
import { ComponentProps } from 'src/lib/component-props';
// @ts-ignore 
import { RouteData } from '@sitecore-content-sdk/nextjs';
// @ts-ignore 
import { CloneableRenderings as FoundationGMICloneableRenderingsRenderingParameters } from "src/.generated/Foundation.GMI.model"
// @ts-ignore 
import { Base as FoundationGMIBaseRenderingParameters } from "src/.generated/Foundation.GMI.model"
// @ts-ignore 
import { Data as FoundationGMIDataContent } from "src/.generated/Foundation.GMI.model"
// @ts-ignore 
import { Data as FoundationGMIDataSettings } from "src/.generated/Foundation.GMI.model"
// @ts-ignore 
import { Data as FoundationGMIDataContributor } from "src/.generated/Foundation.GMI.model"
// @ts-ignore 
import { Data as FoundationGMIDataCards } from "src/.generated/Foundation.GMI.model"
// @ts-ignore 
import { Base as FoundationGMIBase } from "src/.generated/Foundation.GMI.model"
// @ts-ignore 
import { CloneableRenderings as FoundationGMICloneableRenderings } from "src/.generated/Foundation.GMI.model"
// @ts-ignore 
import { Legacy as FoundationGMILegacySearchNx } from "src/.generated/Foundation.GMI.model"
// @ts-ignore 
import { Legacy as FoundationGMILegacyContentDataSources } from "src/.generated/Foundation.GMI.model"
// @ts-ignore 
import { Data as FoundationGMIDataEnums } from "src/.generated/Foundation.GMI.model"
// @ts-ignore 
import { Data as FoundationGMIDataLinks } from "src/.generated/Foundation.GMI.model"
// @ts-ignore 
import { Data as FoundationGMIDataGlobalData } from "src/.generated/Foundation.GMI.model"
// @ts-ignore 
import { Data as FoundationGMIDataUserProfile } from "src/.generated/Foundation.GMI.model"
// @ts-ignore 
import { Site as FoundationGMISite } from "src/.generated/Foundation.GMI.model"
// @ts-ignore 
import { Base as FoundationGMIBasePageFields } from "src/.generated/Foundation.GMI.model"
// @ts-ignore 
import { Base as FoundationGMIBaseComponentFields } from "src/.generated/Foundation.GMI.model"

export namespace CloneableRenderings.RenderingParameters {

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/CloneableRenderings/Rendering Parameters/Accordion Parameters
    */
    export type AccordionParameters = FoundationGMICloneableRenderingsRenderingParameters.RenderingParameters.ComponentWithDatasourceParameters &  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/CloneableRenderings/Rendering Parameters/Accordion Parameters as an Item
    */
    export type AccordionParameters_Item = Omit<Item, 'fields'> & AccordionParameters

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/CloneableRenderings/Rendering Parameters/Accordion Parameters as a Component
    */
    export type AccordionParameters_Component = ComponentProps & AccordionParameters

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/CloneableRenderings/Rendering Parameters/Accordion Parameters as a Route
    */
    export type AccordionParameters_Route = RouteData & AccordionParameters

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/CloneableRenderings/Rendering Parameters/Accordion Parameters
    */
    export type AccordionParametersJson = FoundationGMICloneableRenderingsRenderingParameters.RenderingParameters.ComponentWithDatasourceParametersJson &  {
        

    }
}
export namespace Data.Content {

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Content/Action Tool Bar Button
    */
    export type ActionToolBarButton =  {
        fields?: { 
            /**
            * Represents the Action Type field (58361b16-fb95-45c6-a35d-9acd9cdd3767).
            */
            actionType?: Item;

            /**
            * Represents the Event Position Suffix field (75809b56-bc86-4644-a0ad-c44373d7374c).
            */
            eventPositionSuffix?: Field<string>;

            /**
            * Represents the Button Label field (1fdc998d-2ddc-4ffb-9bfc-3c028518a0a4).
            */
            label?: Field<string>;
        }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Content/Action Tool Bar Button as an Item
    */
    export type ActionToolBarButton_Item = Omit<Item, 'fields'> & ActionToolBarButton

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Content/Action Tool Bar Button as a Component
    */
    export type ActionToolBarButton_Component = ComponentProps & ActionToolBarButton

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Content/Action Tool Bar Button as a Route
    */
    export type ActionToolBarButton_Route = RouteData & ActionToolBarButton

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Data/Content/Action Tool Bar Button
    */
    export type ActionToolBarButtonJson =  {
        
            /**
            * Represents the Action Type field (58361b16-fb95-45c6-a35d-9acd9cdd3767).
            */
            actionType?: {
                jsonValue: Item
            };

            /**
            * Represents the Event Position Suffix field (75809b56-bc86-4644-a0ad-c44373d7374c).
            */
            eventPositionSuffix?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Button Label field (1fdc998d-2ddc-4ffb-9bfc-3c028518a0a4).
            */
            label?: {
                jsonValue: Field<string>
            };


    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Content/Action Tool Bar Buttons Folder
    */
    export type ActionToolBarButtonsFolder =  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Content/Action Tool Bar Buttons Folder as an Item
    */
    export type ActionToolBarButtonsFolder_Item = Omit<Item, 'fields'> & ActionToolBarButtonsFolder

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Content/Action Tool Bar Buttons Folder as a Component
    */
    export type ActionToolBarButtonsFolder_Component = ComponentProps & ActionToolBarButtonsFolder

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Content/Action Tool Bar Buttons Folder as a Route
    */
    export type ActionToolBarButtonsFolder_Route = RouteData & ActionToolBarButtonsFolder

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Data/Content/Action Tool Bar Buttons Folder
    */
    export type ActionToolBarButtonsFolderJson =  {
        

    }
}
export namespace Data.Settings {

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Settings/Alert Banner Settings
    */
    export type AlertBannerSettings =  {
        fields?: { 
            /**
            * Represents the Site Alert field (fecfc65e-8cd7-46d3-b67f-eb7401c41b88).
            */
            siteAlert?: Item[];
        }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Settings/Alert Banner Settings as an Item
    */
    export type AlertBannerSettings_Item = Omit<Item, 'fields'> & AlertBannerSettings

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Settings/Alert Banner Settings as a Component
    */
    export type AlertBannerSettings_Component = ComponentProps & AlertBannerSettings

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Settings/Alert Banner Settings as a Route
    */
    export type AlertBannerSettings_Route = RouteData & AlertBannerSettings

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Data/Settings/Alert Banner Settings
    */
    export type AlertBannerSettingsJson =  {
        
            /**
            * Represents the Site Alert field (fecfc65e-8cd7-46d3-b67f-eb7401c41b88).
            */
            siteAlert?: {
                jsonValue: Item[]
            };


    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Settings/Article Settings
    */
    export type ArticleSettings =  {
        fields?: { 
            /**
            * Represents the Default Author field (9d459a11-75a9-427a-ba53-81707294c026).
            */
            defaultAuthor?: Item;

            /**
            * Represents the heroActionToolBarButtons field (e0c966c7-0319-4a84-8422-b5749a589056).
            */
            heroActionToolBarButtons?: Item[];

            /**
            * Represents the Hide Author By Signature Prefix field (5e1eaf42-cd6d-4867-86ee-df669712355a).
            */
            hideAuthorBySignaturePrefix?: Field<boolean>;

            /**
            * Represents the Show More Count field (80c42f0f-c729-4163-b2f0-fcc06bd116e4).
            */
            ShowMoreCount?: Field<number>;
        }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Settings/Article Settings as an Item
    */
    export type ArticleSettings_Item = Omit<Item, 'fields'> & ArticleSettings

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Settings/Article Settings as a Component
    */
    export type ArticleSettings_Component = ComponentProps & ArticleSettings

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Settings/Article Settings as a Route
    */
    export type ArticleSettings_Route = RouteData & ArticleSettings

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Data/Settings/Article Settings
    */
    export type ArticleSettingsJson =  {
        
            /**
            * Represents the Default Author field (9d459a11-75a9-427a-ba53-81707294c026).
            */
            defaultAuthor?: {
                jsonValue: Item
            };

            /**
            * Represents the heroActionToolBarButtons field (e0c966c7-0319-4a84-8422-b5749a589056).
            */
            heroActionToolBarButtons?: {
                jsonValue: Item[]
            };

            /**
            * Represents the Hide Author By Signature Prefix field (5e1eaf42-cd6d-4867-86ee-df669712355a).
            */
            hideAuthorBySignaturePrefix?: {
                jsonValue: Field<boolean>
            };

            /**
            * Represents the Show More Count field (80c42f0f-c729-4163-b2f0-fcc06bd116e4).
            */
            ShowMoreCount?: {
                jsonValue: Field<number>
            };


    }
}
export namespace Data.Contributor {

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Contributor/AuthorContributor
    */
    export type AuthorContributor =  {
        fields?: { 
            /**
            * Represents the Author Name field (5098a567-70d8-4f12-9904-5b4d3657cb12).
            */
            authorName?: Field<string>;

            /**
            * Represents the Author Profile URL field (079650f0-4bbb-4eeb-9e97-1e6ca20841b9).
            */
            authorProfileURL?: LinkField;

            /**
            * Represents the IRIS Contributor ID field (59cac3c4-9910-4644-8722-e6aeb86ecdd7).
            */
            irisContributorID?: Field<string>;

            /**
            * Represents the isOrganization field (1dd73342-8a17-44fd-907b-b29ff0e56da1).
            */
            isOrganization?: Field<boolean>;
        }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Contributor/AuthorContributor as an Item
    */
    export type AuthorContributor_Item = Omit<Item, 'fields'> & AuthorContributor

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Contributor/AuthorContributor as a Component
    */
    export type AuthorContributor_Component = ComponentProps & AuthorContributor

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Contributor/AuthorContributor as a Route
    */
    export type AuthorContributor_Route = RouteData & AuthorContributor

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Data/Contributor/AuthorContributor
    */
    export type AuthorContributorJson =  {
        
            /**
            * Represents the Author Name field (5098a567-70d8-4f12-9904-5b4d3657cb12).
            */
            authorName?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Author Profile URL field (079650f0-4bbb-4eeb-9e97-1e6ca20841b9).
            */
            authorProfileURL?: {
                jsonValue: LinkField
            };

            /**
            * Represents the IRIS Contributor ID field (59cac3c4-9910-4644-8722-e6aeb86ecdd7).
            */
            irisContributorID?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the isOrganization field (1dd73342-8a17-44fd-907b-b29ff0e56da1).
            */
            isOrganization?: {
                jsonValue: Field<boolean>
            };


    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Contributor/AuthorsType Folder
    */
    export type AuthorsTypeFolder =  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Contributor/AuthorsType Folder as an Item
    */
    export type AuthorsTypeFolder_Item = Omit<Item, 'fields'> & AuthorsTypeFolder

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Contributor/AuthorsType Folder as a Component
    */
    export type AuthorsTypeFolder_Component = ComponentProps & AuthorsTypeFolder

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Contributor/AuthorsType Folder as a Route
    */
    export type AuthorsTypeFolder_Route = RouteData & AuthorsTypeFolder

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Data/Contributor/AuthorsType Folder
    */
    export type AuthorsTypeFolderJson =  {
        

    }
}
export namespace Data.Settings {

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Settings/Badge Settings
    */
    export type BadgeSettings =  {
        fields?: { 
            /**
            * Represents the Badge Label field (c6b8c6c9-3b6f-46a2-808d-fbe17ba9aea8).
            */
            badgeLabel?: Field<string>;

            /**
            * Represents the Badge Link URL field (787602e0-47a9-4e7f-93bf-7dc8bab5b7a6).
            */
            badgeLinkURL?: Field<string>;

            /**
            * Represents the Badge Logo field (2961e1b3-c2b0-47c7-933c-641af2174897).
            */
            badgeLogo?: ImageField;

            /**
            * Represents the Badge Metadata field (a5194c23-a678-4ef2-b153-be98e3960868).
            */
            badgeMetadata?: Field<string>;

            /**
            * Represents the Badge Ribbon field (9d3cb2c0-07ee-4f1e-9587-0b934ad67816).
            */
            badgeRibbon?: ImageField;

            /**
            * Represents the Badge Text field (aef07258-c156-4470-8fc6-e8d432209f20).
            */
            badgeText?: Field<string>;

            /**
            * Represents the Show Badge field (d763fcda-25ff-4084-8637-f7a906ef9550).
            */
            showBadge?: Field<boolean>;

            /**
            * Represents the Show Member Info field (abd11f20-834f-48d5-a9d7-7c07b8ec9b30).
            */
            showMemberInfo?: Field<boolean>;
        }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Settings/Badge Settings as an Item
    */
    export type BadgeSettings_Item = Omit<Item, 'fields'> & BadgeSettings

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Settings/Badge Settings as a Component
    */
    export type BadgeSettings_Component = ComponentProps & BadgeSettings

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Settings/Badge Settings as a Route
    */
    export type BadgeSettings_Route = RouteData & BadgeSettings

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Data/Settings/Badge Settings
    */
    export type BadgeSettingsJson =  {
        
            /**
            * Represents the Badge Label field (c6b8c6c9-3b6f-46a2-808d-fbe17ba9aea8).
            */
            badgeLabel?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Badge Link URL field (787602e0-47a9-4e7f-93bf-7dc8bab5b7a6).
            */
            badgeLinkURL?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Badge Logo field (2961e1b3-c2b0-47c7-933c-641af2174897).
            */
            badgeLogo?: {
                jsonValue: ImageField
            };

            /**
            * Represents the Badge Metadata field (a5194c23-a678-4ef2-b153-be98e3960868).
            */
            badgeMetadata?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Badge Ribbon field (9d3cb2c0-07ee-4f1e-9587-0b934ad67816).
            */
            badgeRibbon?: {
                jsonValue: ImageField
            };

            /**
            * Represents the Badge Text field (aef07258-c156-4470-8fc6-e8d432209f20).
            */
            badgeText?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Show Badge field (d763fcda-25ff-4084-8637-f7a906ef9550).
            */
            showBadge?: {
                jsonValue: Field<boolean>
            };

            /**
            * Represents the Show Member Info field (abd11f20-834f-48d5-a9d7-7c07b8ec9b30).
            */
            showMemberInfo?: {
                jsonValue: Field<boolean>
            };


    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Settings/Bazaar Voice Settings
    */
    export type BazaarVoiceSettings =  {
        fields?: { 
            /**
            * Represents the Bazaar Voice Brand Override field (fa64e134-9364-4b98-813b-7a03800dcbf5).
            */
            bazaarVoiceBrandOverride?: Field<string>;

            /**
            * Represents the Bazaar Voice Environment Override field (395a6f84-795b-4a84-8b28-15d34394c9fa).
            */
            bazaarVoiceEnvironmentOverride?: Field<string>;

            /**
            * Represents the Bazaar Voice Language Override field (93b83641-0a55-46e6-8c85-f539fb91771f).
            */
            bazaarVoiceLanguageOverride?: Field<string>;
        }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Settings/Bazaar Voice Settings as an Item
    */
    export type BazaarVoiceSettings_Item = Omit<Item, 'fields'> & BazaarVoiceSettings

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Settings/Bazaar Voice Settings as a Component
    */
    export type BazaarVoiceSettings_Component = ComponentProps & BazaarVoiceSettings

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Settings/Bazaar Voice Settings as a Route
    */
    export type BazaarVoiceSettings_Route = RouteData & BazaarVoiceSettings

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Data/Settings/Bazaar Voice Settings
    */
    export type BazaarVoiceSettingsJson =  {
        
            /**
            * Represents the Bazaar Voice Brand Override field (fa64e134-9364-4b98-813b-7a03800dcbf5).
            */
            bazaarVoiceBrandOverride?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Bazaar Voice Environment Override field (395a6f84-795b-4a84-8b28-15d34394c9fa).
            */
            bazaarVoiceEnvironmentOverride?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Bazaar Voice Language Override field (93b83641-0a55-46e6-8c85-f539fb91771f).
            */
            bazaarVoiceLanguageOverride?: {
                jsonValue: Field<string>
            };


    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Settings/Buy Now Settings
    */
    export type BuyNowSettings =  {
        fields?: { 
            /**
            * Represents the Pear Commerce Vendor ID field (5e6a9c51-4c2d-4ee1-848f-5491618bf95a).
            */
            pearCommerceVendorId?: Field<string>;

            /**
            * Represents the Pear Commerce Widget ID field (368557a6-7e1f-46f3-b4df-b8a2aefa3b49).
            */
            pearCommerceWidgetId?: Field<string>;
        }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Settings/Buy Now Settings as an Item
    */
    export type BuyNowSettings_Item = Omit<Item, 'fields'> & BuyNowSettings

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Settings/Buy Now Settings as a Component
    */
    export type BuyNowSettings_Component = ComponentProps & BuyNowSettings

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Settings/Buy Now Settings as a Route
    */
    export type BuyNowSettings_Route = RouteData & BuyNowSettings

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Data/Settings/Buy Now Settings
    */
    export type BuyNowSettingsJson =  {
        
            /**
            * Represents the Pear Commerce Vendor ID field (5e6a9c51-4c2d-4ee1-848f-5491618bf95a).
            */
            pearCommerceVendorId?: {
                jsonValue: Field<string>
            };


    }
}
export namespace Data.Cards {

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Cards/Card Detail Level
    */
    export type CardDetailLevel = FoundationGMIBase.BaseData &  {
        fields?: { 
            /**
            * Represents the Fields To Show field (e31c319f-41bf-4a8e-933e-15a1d1faf049).
            */
            fieldsToShow?: Item[];
        }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Cards/Card Detail Level as an Item
    */
    export type CardDetailLevel_Item = Omit<Item, 'fields'> & CardDetailLevel

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Cards/Card Detail Level as a Component
    */
    export type CardDetailLevel_Component = ComponentProps & CardDetailLevel

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Cards/Card Detail Level as a Route
    */
    export type CardDetailLevel_Route = RouteData & CardDetailLevel

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Data/Cards/Card Detail Level
    */
    export type CardDetailLevelJson = FoundationGMIBase.BaseDataJson &  {
        
            /**
            * Represents the Fields To Show field (e31c319f-41bf-4a8e-933e-15a1d1faf049).
            */
            fieldsToShow?: {
                jsonValue: Item[]
            };


    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Cards/Card Detail Level Folder
    */
    export type CardDetailLevelFolder =  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Cards/Card Detail Level Folder as an Item
    */
    export type CardDetailLevelFolder_Item = Omit<Item, 'fields'> & CardDetailLevelFolder

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Cards/Card Detail Level Folder as a Component
    */
    export type CardDetailLevelFolder_Component = ComponentProps & CardDetailLevelFolder

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Cards/Card Detail Level Folder as a Route
    */
    export type CardDetailLevelFolder_Route = RouteData & CardDetailLevelFolder

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Data/Cards/Card Detail Level Folder
    */
    export type CardDetailLevelFolderJson =  {
        

    }
}
export namespace Data.Content {

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Content/Claims
    */
    export type Claims =  {
        fields?: { 
            /**
            * Represents the claim field (08658f28-1360-41dd-98d3-527ebf304dfe).
            */
            claim?: Field<string>;

            /**
            * Represents the code field (fcbc8706-b93e-4539-a0ad-d8f67f364280).
            */
            code?: Field<string>;
        }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Content/Claims as an Item
    */
    export type Claims_Item = Omit<Item, 'fields'> & Claims

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Content/Claims as a Component
    */
    export type Claims_Component = ComponentProps & Claims

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Content/Claims as a Route
    */
    export type Claims_Route = RouteData & Claims

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Data/Content/Claims
    */
    export type ClaimsJson =  {
        
            /**
            * Represents the claim field (08658f28-1360-41dd-98d3-527ebf304dfe).
            */
            claim?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the code field (fcbc8706-b93e-4539-a0ad-d8f67f364280).
            */
            code?: {
                jsonValue: Field<string>
            };


    }
}
export namespace CloneableRenderings {

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/CloneableRenderings/ComponentWithDatasource
    */
    export type ComponentWithDatasource = FoundationGMIBase.BaseComponent &  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/CloneableRenderings/ComponentWithDatasource as an Item
    */
    export type ComponentWithDatasource_Item = Omit<Item, 'fields'> & ComponentWithDatasource

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/CloneableRenderings/ComponentWithDatasource as a Component
    */
    export type ComponentWithDatasource_Component = ComponentProps & ComponentWithDatasource

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/CloneableRenderings/ComponentWithDatasource as a Route
    */
    export type ComponentWithDatasource_Route = RouteData & ComponentWithDatasource

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/CloneableRenderings/ComponentWithDatasource
    */
    export type ComponentWithDatasourceJson = FoundationGMIBase.BaseComponentJson &  {
        

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/CloneableRenderings/ComponentWithDatasource Folder
    */
    export type ComponentWithDatasourceFolder =  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/CloneableRenderings/ComponentWithDatasource Folder as an Item
    */
    export type ComponentWithDatasourceFolder_Item = Omit<Item, 'fields'> & ComponentWithDatasourceFolder

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/CloneableRenderings/ComponentWithDatasource Folder as a Component
    */
    export type ComponentWithDatasourceFolder_Component = ComponentProps & ComponentWithDatasourceFolder

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/CloneableRenderings/ComponentWithDatasource Folder as a Route
    */
    export type ComponentWithDatasourceFolder_Route = RouteData & ComponentWithDatasourceFolder

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/CloneableRenderings/ComponentWithDatasource Folder
    */
    export type ComponentWithDatasourceFolderJson =  {
        

    }
}
export namespace CloneableRenderings.RenderingParameters {

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/CloneableRenderings/Rendering Parameters/ComponentWithDatasource Parameters
    */
    export type ComponentWithDatasourceParameters = FoundationGMIBaseRenderingParameters.RenderingParameters.BaseComponentParameters &  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/CloneableRenderings/Rendering Parameters/ComponentWithDatasource Parameters as an Item
    */
    export type ComponentWithDatasourceParameters_Item = Omit<Item, 'fields'> & ComponentWithDatasourceParameters

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/CloneableRenderings/Rendering Parameters/ComponentWithDatasource Parameters as a Component
    */
    export type ComponentWithDatasourceParameters_Component = ComponentProps & ComponentWithDatasourceParameters

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/CloneableRenderings/Rendering Parameters/ComponentWithDatasource Parameters as a Route
    */
    export type ComponentWithDatasourceParameters_Route = RouteData & ComponentWithDatasourceParameters

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/CloneableRenderings/Rendering Parameters/ComponentWithDatasource Parameters
    */
    export type ComponentWithDatasourceParametersJson = FoundationGMIBaseRenderingParameters.RenderingParameters.BaseComponentParametersJson &  {
        

    }
}
export namespace CloneableRenderings {

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/CloneableRenderings/ComponentWithoutDatasource
    */
    export type ComponentWithoutDatasource = FoundationGMIBase.BaseComponent &  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/CloneableRenderings/ComponentWithoutDatasource as an Item
    */
    export type ComponentWithoutDatasource_Item = Omit<Item, 'fields'> & ComponentWithoutDatasource

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/CloneableRenderings/ComponentWithoutDatasource as a Component
    */
    export type ComponentWithoutDatasource_Component = ComponentProps & ComponentWithoutDatasource

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/CloneableRenderings/ComponentWithoutDatasource as a Route
    */
    export type ComponentWithoutDatasource_Route = RouteData & ComponentWithoutDatasource

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/CloneableRenderings/ComponentWithoutDatasource
    */
    export type ComponentWithoutDatasourceJson = FoundationGMIBase.BaseComponentJson &  {
        

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/CloneableRenderings/ComponentWithoutDatasource Folder
    */
    export type ComponentWithoutDatasourceFolder =  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/CloneableRenderings/ComponentWithoutDatasource Folder as an Item
    */
    export type ComponentWithoutDatasourceFolder_Item = Omit<Item, 'fields'> & ComponentWithoutDatasourceFolder

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/CloneableRenderings/ComponentWithoutDatasource Folder as a Component
    */
    export type ComponentWithoutDatasourceFolder_Component = ComponentProps & ComponentWithoutDatasourceFolder

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/CloneableRenderings/ComponentWithoutDatasource Folder as a Route
    */
    export type ComponentWithoutDatasourceFolder_Route = RouteData & ComponentWithoutDatasourceFolder

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/CloneableRenderings/ComponentWithoutDatasource Folder
    */
    export type ComponentWithoutDatasourceFolderJson =  {
        

    }
}
export namespace CloneableRenderings.RenderingParameters {

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/CloneableRenderings/Rendering Parameters/ComponentWithoutDatasource Parameters
    */
    export type ComponentWithoutDatasourceParameters = FoundationGMIBaseRenderingParameters.RenderingParameters.BaseComponentParameters &  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/CloneableRenderings/Rendering Parameters/ComponentWithoutDatasource Parameters as an Item
    */
    export type ComponentWithoutDatasourceParameters_Item = Omit<Item, 'fields'> & ComponentWithoutDatasourceParameters

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/CloneableRenderings/Rendering Parameters/ComponentWithoutDatasource Parameters as a Component
    */
    export type ComponentWithoutDatasourceParameters_Component = ComponentProps & ComponentWithoutDatasourceParameters

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/CloneableRenderings/Rendering Parameters/ComponentWithoutDatasource Parameters as a Route
    */
    export type ComponentWithoutDatasourceParameters_Route = RouteData & ComponentWithoutDatasourceParameters

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/CloneableRenderings/Rendering Parameters/ComponentWithoutDatasource Parameters
    */
    export type ComponentWithoutDatasourceParametersJson = FoundationGMIBaseRenderingParameters.RenderingParameters.BaseComponentParametersJson &  {
        

    }
}
export namespace Data.Settings {

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Settings/Content Grid Image Override
    */
    export type ContentGridImageOverride =  {
        fields?: { 
            /**
            * Represents the Aspect Ratio field (fbe364c1-2f85-4196-976f-465c06a45968).
            */
            aspectRatio?: Item;

            /**
            * Represents the Content Type field (d96e25c3-8a06-4874-8ee7-49dd3b7bb8b2).
            */
            contentType?: Item;

            /**
            * Represents the Force White Background field (e6059520-21c6-42dd-990b-057206932f47).
            */
            forceWhiteBackground?: Field<boolean>;
        }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Settings/Content Grid Image Override as an Item
    */
    export type ContentGridImageOverride_Item = Omit<Item, 'fields'> & ContentGridImageOverride

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Settings/Content Grid Image Override as a Component
    */
    export type ContentGridImageOverride_Component = ComponentProps & ContentGridImageOverride

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Settings/Content Grid Image Override as a Route
    */
    export type ContentGridImageOverride_Route = RouteData & ContentGridImageOverride

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Data/Settings/Content Grid Image Override
    */
    export type ContentGridImageOverrideJson =  {
        
            /**
            * Represents the Aspect Ratio field (fbe364c1-2f85-4196-976f-465c06a45968).
            */
            aspectRatio?: {
                jsonValue: Item
            };

            /**
            * Represents the Content Type field (d96e25c3-8a06-4874-8ee7-49dd3b7bb8b2).
            */
            contentType?: {
                jsonValue: Item
            };

            /**
            * Represents the Force White Background field (e6059520-21c6-42dd-990b-057206932f47).
            */
            forceWhiteBackground?: {
                jsonValue: Field<boolean>
            };


    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Settings/Content Grid Settings
    */
    export type ContentGridSettings =  {
        fields?: { 
            /**
            * Represents the Content Grid Image field (af873cda-6dcd-41d4-a06d-fe8ee19307d2).
            */
            contentGridImage?: Item[];

            /**
            * Represents the defaultCardDetailLevel field (7b28f26d-eec2-4611-bda0-262b0f3fd28e).
            */
            defaultCardDetailLevel?: Field<string>;

            /**
            * Represents the Default Card Image Aspect Ratio field (343b57ad-7b81-4ae4-baf6-a997352a6a91).
            */
            defaultCardImageAspectRatio?: Item;
        }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Settings/Content Grid Settings as an Item
    */
    export type ContentGridSettings_Item = Omit<Item, 'fields'> & ContentGridSettings

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Settings/Content Grid Settings as a Component
    */
    export type ContentGridSettings_Component = ComponentProps & ContentGridSettings

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Settings/Content Grid Settings as a Route
    */
    export type ContentGridSettings_Route = RouteData & ContentGridSettings

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Data/Settings/Content Grid Settings
    */
    export type ContentGridSettingsJson =  {
        
            /**
            * Represents the Content Grid Image field (af873cda-6dcd-41d4-a06d-fe8ee19307d2).
            */
            contentGridImage?: {
                jsonValue: Item[]
            };

            /**
            * Represents the defaultCardDetailLevel field (7b28f26d-eec2-4611-bda0-262b0f3fd28e).
            */
            defaultCardDetailLevel?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Default Card Image Aspect Ratio field (343b57ad-7b81-4ae4-baf6-a997352a6a91).
            */
            defaultCardImageAspectRatio?: {
                jsonValue: Item
            };
    }
}
export namespace Legacy.SearchNx {

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/SearchNx/Content Override
    */
    export type ContentOverride = FoundationGMIBase.BaseData &  {
        fields?: { 
            /**
            * Represents the CtaText field (070c7227-c975-46cf-8885-925e31166a8e).
            */
            CtaText?: Field<string>;

            /**
            * Represents the Description (Leave blank to use item's description) field (0172cccb-60be-48b6-b4f2-3e4449f75bdd).
            */
            Description?: Field<string>;

            /**
            * Represents the Image (Leave blank to use item's image) field (cf21df29-a3e3-4601-ba0e-4332f10e3a15).
            */
            Image?: ImageField;

            /**
            * Represents the Which content do you want to override? (Only uses first selection) field (cb1bfd8d-deaf-4612-9d60-db51d0633a36).
            */
            OverrideContent?: Field<string>;

            /**
            * Represents the Remove Title Link field (cad87fa1-da39-43c1-81fd-42b3ccfef0e4).
            */
            "Remove Title Link"?: Field<boolean>;

            /**
            * Represents the Tag field (b12074ec-fe8b-4df9-9e57-259e3b141e91).
            */
            Tag?: Field<string>;

            /**
            * Represents the Title (Leave blank to use item's title) field (8e74b05a-f4d3-4af9-9b08-f295ff806f78).
            */
            Title?: Field<string>;

            /**
            * Represents the URL (Leave blank to use item's URL) field (e98f0d50-84b0-40af-a35e-82ce4dd53138).
            */
            Url?: LinkField;
        }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/SearchNx/Content Override as an Item
    */
    export type ContentOverride_Item = Omit<Item, 'fields'> & ContentOverride

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/SearchNx/Content Override as a Component
    */
    export type ContentOverride_Component = ComponentProps & ContentOverride

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/SearchNx/Content Override as a Route
    */
    export type ContentOverride_Route = RouteData & ContentOverride

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Legacy/SearchNx/Content Override
    */
    export type ContentOverrideJson = FoundationGMIBase.BaseDataJson &  {
        
            /**
            * Represents the CtaText field (070c7227-c975-46cf-8885-925e31166a8e).
            */
            CtaText?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Description (Leave blank to use item's description) field (0172cccb-60be-48b6-b4f2-3e4449f75bdd).
            */
            Description?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Image (Leave blank to use item's image) field (cf21df29-a3e3-4601-ba0e-4332f10e3a15).
            */
            Image?: {
                jsonValue: ImageField
            };

            /**
            * Represents the Which content do you want to override? (Only uses first selection) field (cb1bfd8d-deaf-4612-9d60-db51d0633a36).
            */
            OverrideContent?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Remove Title Link field (cad87fa1-da39-43c1-81fd-42b3ccfef0e4).
            */
            "Remove Title Link"?: {
                jsonValue: Field<boolean>
            };

            /**
            * Represents the Tag field (b12074ec-fe8b-4df9-9e57-259e3b141e91).
            */
            Tag?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Title (Leave blank to use item's title) field (8e74b05a-f4d3-4af9-9b08-f295ff806f78).
            */
            Title?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the URL (Leave blank to use item's URL) field (e98f0d50-84b0-40af-a35e-82ce4dd53138).
            */
            Url?: {
                jsonValue: LinkField
            };


    }
}
export namespace Legacy.ContentDataSources {

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/ContentDataSources/ContentDataSourceBase
    */
    export type ContentDataSourceBase = FoundationGMIBase.BaseData &  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/ContentDataSources/ContentDataSourceBase as an Item
    */
    export type ContentDataSourceBase_Item = Omit<Item, 'fields'> & ContentDataSourceBase

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/ContentDataSources/ContentDataSourceBase as a Component
    */
    export type ContentDataSourceBase_Component = ComponentProps & ContentDataSourceBase

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/ContentDataSources/ContentDataSourceBase as a Route
    */
    export type ContentDataSourceBase_Route = RouteData & ContentDataSourceBase

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Legacy/ContentDataSources/ContentDataSourceBase
    */
    export type ContentDataSourceBaseJson = FoundationGMIBase.BaseDataJson &  {
        

    }
}
export namespace Legacy.SearchNx {

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/SearchNx/ContentListDataFolder
    */
    export type ContentListDataFolder =  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/SearchNx/ContentListDataFolder as an Item
    */
    export type ContentListDataFolder_Item = Omit<Item, 'fields'> & ContentListDataFolder

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/SearchNx/ContentListDataFolder as a Component
    */
    export type ContentListDataFolder_Component = ComponentProps & ContentListDataFolder

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/SearchNx/ContentListDataFolder as a Route
    */
    export type ContentListDataFolder_Route = RouteData & ContentListDataFolder

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Legacy/SearchNx/ContentListDataFolder
    */
    export type ContentListDataFolderJson =  {
        

    }
}
export namespace Data.Content {

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Content/ContentType
    */
    export type ContentType = FoundationGMIBase.BaseData &  {
        fields?: { 
            /**
            * Represents the Content Type Default Image field (abdfb60c-33d7-42da-8033-89fcc712f942).
            */
            contentTypeDefaultImage?: ImageField;
        }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Content/ContentType as an Item
    */
    export type ContentType_Item = Omit<Item, 'fields'> & ContentType

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Content/ContentType as a Component
    */
    export type ContentType_Component = ComponentProps & ContentType

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Content/ContentType as a Route
    */
    export type ContentType_Route = RouteData & ContentType

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Data/Content/ContentType
    */
    export type ContentTypeJson = FoundationGMIBase.BaseDataJson &  {
        
            /**
            * Represents the Content Type Default Image field (abdfb60c-33d7-42da-8033-89fcc712f942).
            */
            contentTypeDefaultImage?: {
                jsonValue: ImageField
            };


    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Content/ContentType Folder
    */
    export type ContentTypeFolder =  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Content/ContentType Folder as an Item
    */
    export type ContentTypeFolder_Item = Omit<Item, 'fields'> & ContentTypeFolder

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Content/ContentType Folder as a Component
    */
    export type ContentTypeFolder_Component = ComponentProps & ContentTypeFolder

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Content/ContentType Folder as a Route
    */
    export type ContentTypeFolder_Route = RouteData & ContentTypeFolder

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Data/Content/ContentType Folder
    */
    export type ContentTypeFolderJson =  {
        

    }
}
export namespace Legacy.ContentDataSources {

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/ContentDataSources/CuratedContentDataSource
    */
    export type CuratedContentDataSource = FoundationGMILegacyContentDataSources.ContentDataSources.ContentDataSourceBase &  {
        fields?: { 
            /**
            * Represents the Selected Content field (8db04167-e9db-4fe5-a98c-b726652ed92f).
            */
            Items?: Field<string>;
        }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/ContentDataSources/CuratedContentDataSource as an Item
    */
    export type CuratedContentDataSource_Item = Omit<Item, 'fields'> & CuratedContentDataSource

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/ContentDataSources/CuratedContentDataSource as a Component
    */
    export type CuratedContentDataSource_Component = ComponentProps & CuratedContentDataSource

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/ContentDataSources/CuratedContentDataSource as a Route
    */
    export type CuratedContentDataSource_Route = RouteData & CuratedContentDataSource

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Legacy/ContentDataSources/CuratedContentDataSource
    */
    export type CuratedContentDataSourceJson = FoundationGMILegacyContentDataSources.ContentDataSources.ContentDataSourceBaseJson &  {
        
            /**
            * Represents the Selected Content field (8db04167-e9db-4fe5-a98c-b726652ed92f).
            */
            Items?: {
                jsonValue: Field<string>
            };


    }
}
export namespace Data.Settings {

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Settings/DisableFeatureSettings
    */
    export type DisableFeatureSettings = FoundationGMIBase.BaseData &  {
        fields?: { 
            /**
            * Represents the Disable Features (Current Language Only) field (d39a0bca-e916-47d1-a61f-3169b0205fd2).
            */
            disableFeaturesLanguageSpecific?: Item[];

            /**
            * Represents the Disable Features field (cf647717-7ee7-4554-b746-7f2cfa77f587).
            */
            disableFeaturesShared?: Item[];
        }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Settings/DisableFeatureSettings as an Item
    */
    export type DisableFeatureSettings_Item = Omit<Item, 'fields'> & DisableFeatureSettings

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Settings/DisableFeatureSettings as a Component
    */
    export type DisableFeatureSettings_Component = ComponentProps & DisableFeatureSettings

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Settings/DisableFeatureSettings as a Route
    */
    export type DisableFeatureSettings_Route = RouteData & DisableFeatureSettings

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Data/Settings/DisableFeatureSettings
    */
    export type DisableFeatureSettingsJson = FoundationGMIBase.BaseDataJson &  {
        
            /**
            * Represents the Disable Features (Current Language Only) field (d39a0bca-e916-47d1-a61f-3169b0205fd2).
            */
            disableFeaturesLanguageSpecific?: {
                jsonValue: Item[]
            };

            /**
            * Represents the Disable Features field (cf647717-7ee7-4554-b746-7f2cfa77f587).
            */
            disableFeaturesShared?: {
                jsonValue: Item[]
            };


    }
}
export namespace Legacy.ContentDataSources {

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/ContentDataSources/DynamicContentDataSource
    */
    export type DynamicContentDataSource = FoundationGMILegacyContentDataSources.ContentDataSources.ContentDataSourceBase & 
FoundationGMILegacyContentDataSources.ContentDataSources.FilterableDataSource & 
FoundationGMILegacyContentDataSources.ContentDataSources.SortableDataSource & 
FoundationGMILegacyContentDataSources.ContentDataSources.BaseRelatedDataSource & 
FoundationGMILegacyContentDataSources.ContentDataSources.BaseMetaDataSource & 
FoundationGMILegacyContentDataSources.ContentDataSources.BaseSearchDataSource &  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/ContentDataSources/DynamicContentDataSource as an Item
    */
    export type DynamicContentDataSource_Item = Omit<Item, 'fields'> & DynamicContentDataSource

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/ContentDataSources/DynamicContentDataSource as a Component
    */
    export type DynamicContentDataSource_Component = ComponentProps & DynamicContentDataSource

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/ContentDataSources/DynamicContentDataSource as a Route
    */
    export type DynamicContentDataSource_Route = RouteData & DynamicContentDataSource

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Legacy/ContentDataSources/DynamicContentDataSource
    */
    export type DynamicContentDataSourceJson = FoundationGMILegacyContentDataSources.ContentDataSources.ContentDataSourceBaseJson & 
FoundationGMILegacyContentDataSources.ContentDataSources.FilterableDataSourceJson & 
FoundationGMILegacyContentDataSources.ContentDataSources.SortableDataSourceJson & 
FoundationGMILegacyContentDataSources.ContentDataSources.BaseRelatedDataSourceJson & 
FoundationGMILegacyContentDataSources.ContentDataSources.BaseMetaDataSourceJson & 
FoundationGMILegacyContentDataSources.ContentDataSources.BaseSearchDataSourceJson &  {
        

    }
}
export namespace Data.Settings {

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Settings/EmailSettings
    */
    export type EmailSettings = FoundationGMIBase.BaseData &  {
        fields?: { 
            /**
            * Represents the Email Code field (5910edf0-5929-4ed5-b868-3575088b0331).
            */
            emailCode?: Field<string>;
        }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Settings/EmailSettings as an Item
    */
    export type EmailSettings_Item = Omit<Item, 'fields'> & EmailSettings

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Settings/EmailSettings as a Component
    */
    export type EmailSettings_Component = ComponentProps & EmailSettings

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Settings/EmailSettings as a Route
    */
    export type EmailSettings_Route = RouteData & EmailSettings

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Data/Settings/EmailSettings
    */
    export type EmailSettingsJson = FoundationGMIBase.BaseDataJson &  {
        
            /**
            * Represents the Email Code field (5910edf0-5929-4ed5-b868-3575088b0331).
            */
            emailCode?: {
                jsonValue: Field<string>
            };


    }
}
export namespace Data.Enums {

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Enums/Enum Folder
    */
    export type EnumFolder =  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Enums/Enum Folder as an Item
    */
    export type EnumFolder_Item = Omit<Item, 'fields'> & EnumFolder

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Enums/Enum Folder as a Component
    */
    export type EnumFolder_Component = ComponentProps & EnumFolder

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Enums/Enum Folder as a Route
    */
    export type EnumFolder_Route = RouteData & EnumFolder

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Data/Enums/Enum Folder
    */
    export type EnumFolderJson =  {
        

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Enums/EnumBasic
    */
    export type EnumBasic = FoundationGMIBase.BaseData &  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Enums/EnumBasic as an Item
    */
    export type EnumBasic_Item = Omit<Item, 'fields'> & EnumBasic

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Enums/EnumBasic as a Component
    */
    export type EnumBasic_Component = ComponentProps & EnumBasic

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Enums/EnumBasic as a Route
    */
    export type EnumBasic_Route = RouteData & EnumBasic

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Data/Enums/EnumBasic
    */
    export type EnumBasicJson = FoundationGMIBase.BaseDataJson &  {
        

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Enums/GMIEnum
    */
    export type Gmienum = FoundationGMIBase.BaseData &  {
        fields?: { 
            /**
            * Represents the Value field (fc36755b-1822-4d01-af06-3f294489b179).
            */
            value?: Field<string>;
        }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Enums/GMIEnum as an Item
    */
    export type Gmienum_Item = Omit<Item, 'fields'> & Gmienum

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Enums/GMIEnum as a Component
    */
    export type Gmienum_Component = ComponentProps & Gmienum

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Enums/GMIEnum as a Route
    */
    export type Gmienum_Route = RouteData & Gmienum

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Data/Enums/GMIEnum
    */
    export type GmienumJson = FoundationGMIBase.BaseDataJson &  {
        
            /**
            * Represents the Value field (fc36755b-1822-4d01-af06-3f294489b179).
            */
            value?: {
                jsonValue: Field<string>
            };


    }
}
export namespace Data.Links {

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Links/Generic Link
    */
    export type GenericLink = FoundationGMIBase.BaseData &  {
        fields?: { 
            /**
            * Represents the Link field (1e5322d4-6c42-466f-ad23-32a4c7aeacc3).
            */
            link?: LinkField;
        }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Links/Generic Link as an Item
    */
    export type GenericLink_Item = Omit<Item, 'fields'> & GenericLink

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Links/Generic Link as a Component
    */
    export type GenericLink_Component = ComponentProps & GenericLink

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Links/Generic Link as a Route
    */
    export type GenericLink_Route = RouteData & GenericLink

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Data/Links/Generic Link
    */
    export type GenericLinkJson = FoundationGMIBase.BaseDataJson &  {
        
            /**
            * Represents the Link field (1e5322d4-6c42-466f-ad23-32a4c7aeacc3).
            */
            link?: {
                jsonValue: LinkField
            };


    }
}
export namespace Data.GlobalData {

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Global Data/Global Folder
    */
    export type GlobalFolder =  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Global Data/Global Folder as an Item
    */
    export type GlobalFolder_Item = Omit<Item, 'fields'> & GlobalFolder

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Global Data/Global Folder as a Component
    */
    export type GlobalFolder_Component = ComponentProps & GlobalFolder

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Global Data/Global Folder as a Route
    */
    export type GlobalFolder_Route = RouteData & GlobalFolder

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Data/Global Data/Global Folder
    */
    export type GlobalFolderJson =  {
        

    }
}
export namespace Data.Settings {

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Settings/Header Settings
    */
    export type HeaderSettings =  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Settings/Header Settings as an Item
    */
    export type HeaderSettings_Item = Omit<Item, 'fields'> & HeaderSettings

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Settings/Header Settings as a Component
    */
    export type HeaderSettings_Component = ComponentProps & HeaderSettings

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Settings/Header Settings as a Route
    */
    export type HeaderSettings_Route = RouteData & HeaderSettings

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Data/Settings/Header Settings
    */
    export type HeaderSettingsJson =  {
        

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Settings/Login And Registration Settings
    */
    export type LoginAndRegistrationSettings =  {
        fields?: { 
            /**
            * Represents the enableDOB field (9ec72c97-1fbd-4421-a622-f1eceb8ba217).
            */
            enableDOB?: Field<boolean>;

            /**
            * Represents the enableQuestionsDropdown field (1fab19e4-3919-492e-95ab-03d4849ba7ab).
            */
            enableQuestionsDropdown?: Field<boolean>;

            /**
            * Represents the Enable Remember Me field (8219e3da-393c-414b-a892-d7aad2c57d51).
            */
            enableRememberMe?: Field<boolean>;

            /**
            * Represents the enableSocialLogin field (46e4a6e9-2307-4067-8790-6e9e77106494).
            */
            enableSocialLogin?: Field<boolean>;

            /**
            * Represents the Hide Social Login with Facebook option field (59f90da7-f9ee-4f44-9ce8-786f611bd79c).
            */
            hideSocialLoginWithFacebook?: Field<boolean>;

            /**
            * Represents the Hide Social Login with Google option field (4bdfa92c-d7ea-481e-86c8-e2a2ba47842f).
            */
            hideSocialLoginWithGoogle?: Field<boolean>;

            /**
            * Represents the Login Page field (17f54e25-21b9-4d79-80ce-305681f68d7f).
            */
            loginPage?: LinkField;

            /**
            * Represents the My Profile Page field (af887fbb-a04b-420c-bdc1-67dd1fb2aa2f).
            */
            myProfilePage?: LinkField;

            /**
            * Represents the Registration Page field (98352290-2477-4dc5-a8c1-71c04b2d3e31).
            */
            registrationPage?: LinkField;
        }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Settings/Login And Registration Settings as an Item
    */
    export type LoginAndRegistrationSettings_Item = Omit<Item, 'fields'> & LoginAndRegistrationSettings

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Settings/Login And Registration Settings as a Component
    */
    export type LoginAndRegistrationSettings_Component = ComponentProps & LoginAndRegistrationSettings

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Settings/Login And Registration Settings as a Route
    */
    export type LoginAndRegistrationSettings_Route = RouteData & LoginAndRegistrationSettings

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Data/Settings/Login And Registration Settings
    */
    export type LoginAndRegistrationSettingsJson =  {
        
            /**
            * Represents the enableDOB field (9ec72c97-1fbd-4421-a622-f1eceb8ba217).
            */
            enableDOB?: {
                jsonValue: Field<boolean>
            };

            /**
            * Represents the enableQuestionsDropdown field (1fab19e4-3919-492e-95ab-03d4849ba7ab).
            */
            enableQuestionsDropdown?: {
                jsonValue: Field<boolean>
            };

            /**
            * Represents the Enable Remember Me field (8219e3da-393c-414b-a892-d7aad2c57d51).
            */
            enableRememberMe?: {
                jsonValue: Field<boolean>
            };

            /**
            * Represents the enableSocialLogin field (46e4a6e9-2307-4067-8790-6e9e77106494).
            */
            enableSocialLogin?: {
                jsonValue: Field<boolean>
            };

            /**
            * Represents the Hide Social Login with Facebook option field (59f90da7-f9ee-4f44-9ce8-786f611bd79c).
            */
            hideSocialLoginWithFacebook?: {
                jsonValue: Field<boolean>
            };

            /**
            * Represents the Hide Social Login with Google option field (4bdfa92c-d7ea-481e-86c8-e2a2ba47842f).
            */
            hideSocialLoginWithGoogle?: {
                jsonValue: Field<boolean>
            };

            /**
            * Represents the Login Page field (17f54e25-21b9-4d79-80ce-305681f68d7f).
            */
            loginPage?: {
                jsonValue: LinkField
            };

            /**
            * Represents the My Profile Page field (af887fbb-a04b-420c-bdc1-67dd1fb2aa2f).
            */
            myProfilePage?: {
                jsonValue: LinkField
            };

            /**
            * Represents the Registration Page field (98352290-2477-4dc5-a8c1-71c04b2d3e31).
            */
            registrationPage?: {
                jsonValue: LinkField
            };


    }
}
export namespace Legacy.ContentDataSources {

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/ContentDataSources/MetaDataContentDataSource
    */
    export type MetaDataContentDataSource = FoundationGMILegacyContentDataSources.ContentDataSources.ContentDataSourceBase & 
FoundationGMILegacyContentDataSources.ContentDataSources.FilterableDataSource & 
FoundationGMILegacyContentDataSources.ContentDataSources.SortableDataSource & 
FoundationGMILegacyContentDataSources.ContentDataSources.BaseMetaDataSource &  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/ContentDataSources/MetaDataContentDataSource as an Item
    */
    export type MetaDataContentDataSource_Item = Omit<Item, 'fields'> & MetaDataContentDataSource

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/ContentDataSources/MetaDataContentDataSource as a Component
    */
    export type MetaDataContentDataSource_Component = ComponentProps & MetaDataContentDataSource

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/ContentDataSources/MetaDataContentDataSource as a Route
    */
    export type MetaDataContentDataSource_Route = RouteData & MetaDataContentDataSource

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Legacy/ContentDataSources/MetaDataContentDataSource
    */
    export type MetaDataContentDataSourceJson = FoundationGMILegacyContentDataSources.ContentDataSources.ContentDataSourceBaseJson & 
FoundationGMILegacyContentDataSources.ContentDataSources.FilterableDataSourceJson & 
FoundationGMILegacyContentDataSources.ContentDataSources.SortableDataSourceJson & 
FoundationGMILegacyContentDataSources.ContentDataSources.BaseMetaDataSourceJson &  {
        

    }
}
export namespace Legacy.SearchNx {

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/SearchNx/Metadata Selector Exclusion Settings
    */
    export type MetadataSelectorExclusionSettings = FoundationGMIBase.BaseData &  {
        fields?: { 
            /**
            * Represents the Meta Data Exclusion settings field (b401438a-3aa1-4e1c-970d-8dc24b8b737d).
            */
            metadataExclusionSettings?: Field<string>;
        }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/SearchNx/Metadata Selector Exclusion Settings as an Item
    */
    export type MetadataSelectorExclusionSettings_Item = Omit<Item, 'fields'> & MetadataSelectorExclusionSettings

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/SearchNx/Metadata Selector Exclusion Settings as a Component
    */
    export type MetadataSelectorExclusionSettings_Component = ComponentProps & MetadataSelectorExclusionSettings

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/SearchNx/Metadata Selector Exclusion Settings as a Route
    */
    export type MetadataSelectorExclusionSettings_Route = RouteData & MetadataSelectorExclusionSettings

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Legacy/SearchNx/Metadata Selector Exclusion Settings
    */
    export type MetadataSelectorExclusionSettingsJson = FoundationGMIBase.BaseDataJson &  {
        
            /**
            * Represents the Meta Data Exclusion settings field (b401438a-3aa1-4e1c-970d-8dc24b8b737d).
            */
            metadataExclusionSettings?: {
                jsonValue: Field<string>
            };


    }
}
export namespace CloneableRenderings.RenderingParameters {

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/CloneableRenderings/Rendering Parameters/PearCommerceProduct Parameters
    */
    export type PearCommerceProductParameters = FoundationGMICloneableRenderingsRenderingParameters.RenderingParameters.ComponentWithoutDatasourceParameters &  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/CloneableRenderings/Rendering Parameters/PearCommerceProduct Parameters as an Item
    */
    export type PearCommerceProductParameters_Item = Omit<Item, 'fields'> & PearCommerceProductParameters

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/CloneableRenderings/Rendering Parameters/PearCommerceProduct Parameters as a Component
    */
    export type PearCommerceProductParameters_Component = ComponentProps & PearCommerceProductParameters

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/CloneableRenderings/Rendering Parameters/PearCommerceProduct Parameters as a Route
    */
    export type PearCommerceProductParameters_Route = RouteData & PearCommerceProductParameters

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/CloneableRenderings/Rendering Parameters/PearCommerceProduct Parameters
    */
    export type PearCommerceProductParametersJson = FoundationGMICloneableRenderingsRenderingParameters.RenderingParameters.ComponentWithoutDatasourceParametersJson &  {
        

    }
}
export namespace Data.Settings {

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Settings/Product Detail Settings
    */
    export type ProductDetailSettings =  {
        fields?: { 
            /**
            * Represents the Select Action buttons included in the Product Content field (2df184bd-6202-4028-8be8-7b77b7a73f14).
            */
            contentActionToolBarButtons?: Item[];

            /**
            * Represents the Select Claim included in the Product Content field (9a21b63b-cca7-4645-8bad-66c82017bad5).
            */
            contentClaims?: Item[];

            /**
            * Represents the Analytics Event Position for Content Action Tool Bar  field (7b5fe9ad-7ec6-44f7-abc0-2d50fe31e599).
            */
            contentEventPosition?: Field<string>;

            /**
            * Represents the Hide Product Consumer Statements field (7ed9a48c-a8f6-4dfb-bdcf-72f08d32f7d9).
            */
            hideProductConsumerStatements?: Field<boolean>;

            /**
            * Represents the Hide Product Hero field (1297a62e-e728-44ca-b942-d8df4a9c50e7).
            */
            hideProductHero?: Field<boolean>;

            /**
            * Represents the Max Claims Indicator Count field (fb4a7ea4-7398-438c-a913-dbb865dde577).
            */
            maxClaimsIndicatorCount?: Field<number>;

            /**
            * Represents the maxImagesOnHero field (0087a6de-f98f-4be4-b998-9841be71dda9).
            */
            maxImagesOnHero?: Field<number>;

            /**
            * Represents the primaryCtaLabel field (76a4c156-8788-44da-8202-3f2dfa8b6834).
            */
            primaryCtaLabel?: Field<string>;

            /**
            * Represents the primaryCtaLink field (cf9dcbe1-1a8d-4cb8-adfe-4201d072bcac).
            */
            primaryCtaLink?: Field<string>;

            /**
            * Represents the Select Action buttons included in the Product Hero field (f55820d4-a7a6-4c48-840f-f58df552cab3).
            */
            productHeroActionToolBar?: Item[];

            /**
            * Represents the Analytics Event Position for Hero Action Tool Bar field (897bee07-4ee5-40c2-844a-39755e004e7f).
            */
            productHeroEventPosition?: Field<string>;

            /**
            * Represents the secondaryCtaLabel field (96d54763-9df9-42b7-ba2d-189b821ecbfe).
            */
            secondaryCtaLabel?: Field<string>;

            /**
            * Represents the secondaryCtaLink field (dec0c50a-26d5-4ce7-9af5-4f75afdee488).
            */
            secondaryCtaLink?: Field<string>;

            /**
            * Represents the showCaseCount field (82d8fc60-568b-40df-9996-039e2777cb22).
            */
            showCaseCount?: Field<boolean>;

            /**
            * Represents the showPrimaryCta field (20e885ca-bc13-4837-aa1a-cb479c94b16f).
            */
            showPrimaryCta?: Field<boolean>;

            /**
            * Represents the showProductCode field (12f711e6-279e-46a8-a135-df77704f8b03).
            */
            showProductCode?: Field<boolean>;

            /**
            * Represents the showSecondaryCta field (732f9d9f-3b55-4151-b6ca-30359e1dbb1b).
            */
            showSecondaryCta?: Field<boolean>;

            /**
            * Represents the verticallyAlignTitle field (361df3ee-1a9b-40bf-98a8-3846584cb5f1).
            */
            verticallyAlignTitle?: Field<boolean>;
        }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Settings/Product Detail Settings as an Item
    */
    export type ProductDetailSettings_Item = Omit<Item, 'fields'> & ProductDetailSettings

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Settings/Product Detail Settings as a Component
    */
    export type ProductDetailSettings_Component = ComponentProps & ProductDetailSettings

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Settings/Product Detail Settings as a Route
    */
    export type ProductDetailSettings_Route = RouteData & ProductDetailSettings

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Data/Settings/Product Detail Settings
    */
    export type ProductDetailSettingsJson =  {
        
            /**
            * Represents the Select Action buttons included in the Product Content field (2df184bd-6202-4028-8be8-7b77b7a73f14).
            */
            contentActionToolBarButtons?: {
                jsonValue: Item[]
            };

            /**
            * Represents the Select Claim included in the Product Content field (9a21b63b-cca7-4645-8bad-66c82017bad5).
            */
            contentClaims?: {
                jsonValue: Item[]
            };

            /**
            * Represents the Analytics Event Position for Content Action Tool Bar  field (7b5fe9ad-7ec6-44f7-abc0-2d50fe31e599).
            */
            contentEventPosition?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Hide Product Consumer Statements field (7ed9a48c-a8f6-4dfb-bdcf-72f08d32f7d9).
            */
            hideProductConsumerStatements?: {
                jsonValue: Field<boolean>
            };

            /**
            * Represents the Hide Product Hero field (1297a62e-e728-44ca-b942-d8df4a9c50e7).
            */
            hideProductHero?: {
                jsonValue: Field<boolean>
            };

            /**
            * Represents the Max Claims Indicator Count field (fb4a7ea4-7398-438c-a913-dbb865dde577).
            */
            maxClaimsIndicatorCount?: {
                jsonValue: Field<number>
            };

            /**
            * Represents the maxImagesOnHero field (0087a6de-f98f-4be4-b998-9841be71dda9).
            */
            maxImagesOnHero?: {
                jsonValue: Field<number>
            };

            /**
            * Represents the primaryCtaLabel field (76a4c156-8788-44da-8202-3f2dfa8b6834).
            */
            primaryCtaLabel?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the primaryCtaLink field (cf9dcbe1-1a8d-4cb8-adfe-4201d072bcac).
            */
            primaryCtaLink?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Select Action buttons included in the Product Hero field (f55820d4-a7a6-4c48-840f-f58df552cab3).
            */
            productHeroActionToolBar?: {
                jsonValue: Item[]
            };

            /**
            * Represents the Analytics Event Position for Hero Action Tool Bar field (897bee07-4ee5-40c2-844a-39755e004e7f).
            */
            productHeroEventPosition?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the secondaryCtaLabel field (96d54763-9df9-42b7-ba2d-189b821ecbfe).
            */
            secondaryCtaLabel?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the secondaryCtaLink field (dec0c50a-26d5-4ce7-9af5-4f75afdee488).
            */
            secondaryCtaLink?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the showCaseCount field (82d8fc60-568b-40df-9996-039e2777cb22).
            */
            showCaseCount?: {
                jsonValue: Field<boolean>
            };

            /**
            * Represents the showPrimaryCta field (20e885ca-bc13-4837-aa1a-cb479c94b16f).
            */
            showPrimaryCta?: {
                jsonValue: Field<boolean>
            };

            /**
            * Represents the showProductCode field (12f711e6-279e-46a8-a135-df77704f8b03).
            */
            showProductCode?: {
                jsonValue: Field<boolean>
            };

            /**
            * Represents the showSecondaryCta field (732f9d9f-3b55-4151-b6ca-30359e1dbb1b).
            */
            showSecondaryCta?: {
                jsonValue: Field<boolean>
            };

            /**
            * Represents the verticallyAlignTitle field (361df3ee-1a9b-40bf-98a8-3846584cb5f1).
            */
            verticallyAlignTitle?: {
                jsonValue: Field<boolean>
            };


    }
}
export namespace Legacy.SearchNx {

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/SearchNx/Property Filter
    */
    export type PropertyFilter =  {
        fields?: { 
            /**
            * Represents the Exclude field (5ef0949f-8357-4dc0-8e14-82c38eafe53e).
            */
            Exclude?: Field<boolean>;

            /**
            * Represents the Property Name field (9862e32b-c5c2-4497-a549-789522454829).
            */
            "Property Name"?: Field<string>;

            /**
            * Represents the Property Value field (f2d28a72-9bcc-4810-9f77-f96c5de4eb10).
            */
            "Property Value"?: Field<string>;
        }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/SearchNx/Property Filter as an Item
    */
    export type PropertyFilter_Item = Omit<Item, 'fields'> & PropertyFilter

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/SearchNx/Property Filter as a Component
    */
    export type PropertyFilter_Component = ComponentProps & PropertyFilter

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/SearchNx/Property Filter as a Route
    */
    export type PropertyFilter_Route = RouteData & PropertyFilter

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Legacy/SearchNx/Property Filter
    */
    export type PropertyFilterJson =  {
        
            /**
            * Represents the Exclude field (5ef0949f-8357-4dc0-8e14-82c38eafe53e).
            */
            Exclude?: {
                jsonValue: Field<boolean>
            };

            /**
            * Represents the Property Name field (9862e32b-c5c2-4497-a549-789522454829).
            */
            "Property Name"?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Property Value field (f2d28a72-9bcc-4810-9f77-f96c5de4eb10).
            */
            "Property Value"?: {
                jsonValue: Field<string>
            };


    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/SearchNx/Property Filter Folder
    */
    export type PropertyFilterFolder =  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/SearchNx/Property Filter Folder as an Item
    */
    export type PropertyFilterFolder_Item = Omit<Item, 'fields'> & PropertyFilterFolder

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/SearchNx/Property Filter Folder as a Component
    */
    export type PropertyFilterFolder_Component = ComponentProps & PropertyFilterFolder

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/SearchNx/Property Filter Folder as a Route
    */
    export type PropertyFilterFolder_Route = RouteData & PropertyFilterFolder

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Legacy/SearchNx/Property Filter Folder
    */
    export type PropertyFilterFolderJson =  {
        

    }
}
export namespace Data.UserProfile.QuestionsInfo {

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/UserProfile/QuestionsInfo/QuestionsInfo
    */
    export type QuestionsInfo =  {
        fields?: { 
            /**
            * Represents the answer field (b8f120d0-ae19-466f-9a2c-d51e0ad8971e).
            */
            answer?: Field<string>;

            /**
            * Represents the answerId field (299d706a-aca9-41d6-96e9-06869f58c484).
            */
            answerId?: Field<string>;
        }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/UserProfile/QuestionsInfo/QuestionsInfo as an Item
    */
    export type QuestionsInfo_Item = Omit<Item, 'fields'> & QuestionsInfo

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/UserProfile/QuestionsInfo/QuestionsInfo as a Component
    */
    export type QuestionsInfo_Component = ComponentProps & QuestionsInfo

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/UserProfile/QuestionsInfo/QuestionsInfo as a Route
    */
    export type QuestionsInfo_Route = RouteData & QuestionsInfo

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Data/UserProfile/QuestionsInfo/QuestionsInfo
    */
    export type QuestionsInfoJson =  {
        
            /**
            * Represents the answer field (b8f120d0-ae19-466f-9a2c-d51e0ad8971e).
            */
            answer?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the answerId field (299d706a-aca9-41d6-96e9-06869f58c484).
            */
            answerId?: {
                jsonValue: Field<string>
            };


    }
}
export namespace Data.Settings {

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Settings/Recipe Detail Site Settings
    */
    export type RecipeDetailSiteSettings =  {
        fields?: { 
            /**
            * Represents the Enable Table Display Format field (13504830-1344-4ded-b4bb-ed809e38c4b5).
            */
            enableTableDisplay?: Field<boolean>;

            /**
            * Represents the Select Action buttons included in the RDP Hero field (48d98f92-8c6b-4321-8cc4-cc8d1da73fa6).
            */
            heroActionToolBarButtons?: Item[];

            /**
            * Represents the Analytics Event Position for Hero Action Tool Bar  field (b2a5f7db-e35a-4b4d-ab3e-070bd193cef5).
            */
            heroEventPosition?: Field<string>;

            /**
            * Represents the Hide Ingredients Component field (d99c563a-44c2-4582-9d64-b0151e258bf3).
            */
            hideIngredientsComponent?: Field<boolean>;

            /**
            * Represents the Hide Rdp Header field (c577a84c-b10c-4db6-82c8-78d607a3cccc).
            */
            hideRdpHeader?: Field<boolean>;

            /**
            * Represents the Hide Rdp Header Attribute List field (0d70200b-fc7a-4beb-9a65-006bf43f024a).
            */
            hideRdpHeaderAttributeList?: Item[];

            /**
            * Represents the Hide Rdp Header Attributes field (892a811a-724b-495b-9110-36a1d86479ad).
            */
            hideRdpHeaderAttributes?: Field<boolean>;

            /**
            * Represents the Hide Rdp Header Headline field (19d55e4e-9174-4fa5-9879-e2d6060feebd).
            */
            hideRdpHeaderHeadline?: Field<boolean>;

            /**
            * Represents the Hide Rdp Header Ratings And Reviews field (a6c8ab78-f838-480f-8eea-49bf5599386c).
            */
            hideRdpHeaderRatingsAndReviews?: Field<boolean>;

            /**
            * Represents the Hide Rdp Header Video field (abec3586-d209-495d-a0ef-ff24a0c9b6a7).
            */
            hideRdpHeaderVideo?: Field<boolean>;

            /**
            * Represents the Hide Rdp Hero field (35412d7a-b138-49fb-aed2-1466a5c47961).
            */
            hideRdpHero?: Field<boolean>;

            /**
            * Represents the Hide Rdp Hero Attribute List field (7dabb340-d7d4-4a48-ab8b-6b2737fb6d3c).
            */
            hideRdpHeroAttributeList?: Item[];

            /**
            * Represents the Hide Rdp Hero Breadcrumb field (e4f892f6-31bd-412d-a415-84687101b50c).
            */
            hideRdpHeroBreadcrumb?: Field<boolean>;

            /**
            * Represents the Hide Rdp Hero By Author Signature Prefix field (ac17b314-b24f-4352-b2ba-fdaec9ea67ea).
            */
            hideRdpHeroByAuthorSignaturePrefix?: Field<boolean>;

            /**
            * Represents the Hide Rdp Hero By Line field (592f07da-28b9-4461-a2cb-fe4c338d1182).
            */
            hideRdpHeroByLine?: Field<boolean>;

            /**
            * Represents the Hide Rdp Hero Image field (d88b12fe-0248-4aff-8912-a7a25b4c7a79).
            */
            hideRdpHeroImage?: Field<boolean>;

            /**
            * Represents the Hide Rdp Hero Ratings And Reviews field (f846f567-85e7-4b52-8b72-254c2a7798ff).
            */
            hideRdpHeroRatingsAndReviews?: Field<boolean>;

            /**
            * Represents the Hide Recipe Kitchen Tips field (a84f8798-067e-4324-acca-a665a7e52d28).
            */
            hideRdpRecipeTips?: Item[];

            /**
            * Represents the Hide Recipe FAQ Section field (ad2f5587-8e47-4800-bd4d-df586b62d38f).
            */
            hideRecipeFAQ?: Field<boolean>;

            /**
            * Represents the Hide Recipe SEO Section field (aea91398-3d12-4f80-9790-a43094201ef0).
            */
            hideRecipeSeoContent?: Field<boolean>;

            /**
            * Represents the Hide Shopping (Pear Commerce) field (c337b373-4cd8-4dd9-b63e-b02614a93367).
            */
            hideShopping?: Field<boolean>;

            /**
            * Represents the Select Action buttons included in the Recipe Ingredients Content field (d99ea715-6643-4719-bf41-58c5027758e2).
            */
            ingredientsContentActionToolBar?: Item[];

            /**
            * Represents the Analytics Event Position for Ingredients Action Tool Bar field (3fa2413c-2857-4f39-8fb9-3c0552736321).
            */
            ingredientsEventPosition?: Field<string>;

            /**
            * Represents the Instructions View field (97106914-2ebf-4d10-91e3-82f4a95775c3).
            */
            instructionsView?: Field<string>;

            /**
            * Represents the Kitchen Tested Page Link field (8c35f3b1-f48d-4188-a079-c86221b14753).
            */
            kitchenTestedLink?: LinkField;

            /**
            * Represents the Select Action buttons included in the Recipe SEO field (ed6af6ce-1405-49d9-8ffd-65700a412823).
            */
            seoActionToolBarButtons?: Item[];

            /**
            * Represents the Analytics Event Position for SEO Action Tool Bar  field (9f77ed2d-c221-4cf2-a7e6-1c335010cc0c).
            */
            seoEventPosition?: Field<string>;
        }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Settings/Recipe Detail Site Settings as an Item
    */
    export type RecipeDetailSiteSettings_Item = Omit<Item, 'fields'> & RecipeDetailSiteSettings

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Settings/Recipe Detail Site Settings as a Component
    */
    export type RecipeDetailSiteSettings_Component = ComponentProps & RecipeDetailSiteSettings

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Settings/Recipe Detail Site Settings as a Route
    */
    export type RecipeDetailSiteSettings_Route = RouteData & RecipeDetailSiteSettings

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Data/Settings/Recipe Detail Site Settings
    */
    export type RecipeDetailSiteSettingsJson =  {
        
            /**
            * Represents the Enable Table Display Format field (13504830-1344-4ded-b4bb-ed809e38c4b5).
            */
            enableTableDisplay?: {
                jsonValue: Field<boolean>
            };

            /**
            * Represents the Select Action buttons included in the RDP Hero field (48d98f92-8c6b-4321-8cc4-cc8d1da73fa6).
            */
            heroActionToolBarButtons?: {
                jsonValue: Item[]
            };

            /**
            * Represents the Analytics Event Position for Hero Action Tool Bar  field (b2a5f7db-e35a-4b4d-ab3e-070bd193cef5).
            */
            heroEventPosition?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Hide Ingredients Component field (d99c563a-44c2-4582-9d64-b0151e258bf3).
            */
            hideIngredientsComponent?: {
                jsonValue: Field<boolean>
            };

            /**
            * Represents the Hide Rdp Header field (c577a84c-b10c-4db6-82c8-78d607a3cccc).
            */
            hideRdpHeader?: {
                jsonValue: Field<boolean>
            };

            /**
            * Represents the Hide Rdp Header Attribute List field (0d70200b-fc7a-4beb-9a65-006bf43f024a).
            */
            hideRdpHeaderAttributeList?: {
                jsonValue: Item[]
            };

            /**
            * Represents the Hide Rdp Header Attributes field (892a811a-724b-495b-9110-36a1d86479ad).
            */
            hideRdpHeaderAttributes?: {
                jsonValue: Field<boolean>
            };

            /**
            * Represents the Hide Rdp Header Headline field (19d55e4e-9174-4fa5-9879-e2d6060feebd).
            */
            hideRdpHeaderHeadline?: {
                jsonValue: Field<boolean>
            };

            /**
            * Represents the Hide Rdp Header Ratings And Reviews field (a6c8ab78-f838-480f-8eea-49bf5599386c).
            */
            hideRdpHeaderRatingsAndReviews?: {
                jsonValue: Field<boolean>
            };

            /**
            * Represents the Hide Rdp Header Video field (abec3586-d209-495d-a0ef-ff24a0c9b6a7).
            */
            hideRdpHeaderVideo?: {
                jsonValue: Field<boolean>
            };

            /**
            * Represents the Hide Rdp Hero field (35412d7a-b138-49fb-aed2-1466a5c47961).
            */
            hideRdpHero?: {
                jsonValue: Field<boolean>
            };

            /**
            * Represents the Hide Rdp Hero Attribute List field (7dabb340-d7d4-4a48-ab8b-6b2737fb6d3c).
            */
            hideRdpHeroAttributeList?: {
                jsonValue: Item[]
            };

            /**
            * Represents the Hide Rdp Hero Breadcrumb field (e4f892f6-31bd-412d-a415-84687101b50c).
            */
            hideRdpHeroBreadcrumb?: {
                jsonValue: Field<boolean>
            };

            /**
            * Represents the Hide Rdp Hero By Author Signature Prefix field (ac17b314-b24f-4352-b2ba-fdaec9ea67ea).
            */
            hideRdpHeroByAuthorSignaturePrefix?: {
                jsonValue: Field<boolean>
            };

            /**
            * Represents the Hide Rdp Hero By Line field (592f07da-28b9-4461-a2cb-fe4c338d1182).
            */
            hideRdpHeroByLine?: {
                jsonValue: Field<boolean>
            };

            /**
            * Represents the Hide Rdp Hero Image field (d88b12fe-0248-4aff-8912-a7a25b4c7a79).
            */
            hideRdpHeroImage?: {
                jsonValue: Field<boolean>
            };

            /**
            * Represents the Hide Rdp Hero Ratings And Reviews field (f846f567-85e7-4b52-8b72-254c2a7798ff).
            */
            hideRdpHeroRatingsAndReviews?: {
                jsonValue: Field<boolean>
            };

            /**
            * Represents the Hide Recipe Kitchen Tips field (a84f8798-067e-4324-acca-a665a7e52d28).
            */
            hideRdpRecipeTips?: {
                jsonValue: Item[]
            };

            /**
            * Represents the Hide Recipe FAQ Section field (ad2f5587-8e47-4800-bd4d-df586b62d38f).
            */
            hideRecipeFAQ?: {
                jsonValue: Field<boolean>
            };

            /**
            * Represents the Hide Recipe SEO Section field (aea91398-3d12-4f80-9790-a43094201ef0).
            */
            hideRecipeSeoContent?: {
                jsonValue: Field<boolean>
            };

            /**
            * Represents the Hide Shopping (Pear Commerce) field (c337b373-4cd8-4dd9-b63e-b02614a93367).
            */
            hideShopping?: {
                jsonValue: Field<boolean>
            };

            /**
            * Represents the Select Action buttons included in the Recipe Ingredients Content field (d99ea715-6643-4719-bf41-58c5027758e2).
            */
            ingredientsContentActionToolBar?: {
                jsonValue: Item[]
            };

            /**
            * Represents the Analytics Event Position for Ingredients Action Tool Bar field (3fa2413c-2857-4f39-8fb9-3c0552736321).
            */
            ingredientsEventPosition?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Instructions View field (97106914-2ebf-4d10-91e3-82f4a95775c3).
            */
            instructionsView?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Kitchen Tested Page Link field (8c35f3b1-f48d-4188-a079-c86221b14753).
            */
            kitchenTestedLink?: {
                jsonValue: LinkField
            };

            /**
            * Represents the Select Action buttons included in the Recipe SEO field (ed6af6ce-1405-49d9-8ffd-65700a412823).
            */
            seoActionToolBarButtons?: {
                jsonValue: Item[]
            };

            /**
            * Represents the Analytics Event Position for SEO Action Tool Bar  field (9f77ed2d-c221-4cf2-a7e6-1c335010cc0c).
            */
            seoEventPosition?: {
                jsonValue: Field<string>
            };


    }
}
export namespace Legacy.ContentDataSources {

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/ContentDataSources/RelatedContentDataSource
    */
    export type RelatedContentDataSource = FoundationGMILegacyContentDataSources.ContentDataSources.ContentDataSourceBase & 
FoundationGMILegacyContentDataSources.ContentDataSources.FilterableDataSource & 
FoundationGMILegacyContentDataSources.ContentDataSources.SortableDataSource & 
FoundationGMILegacyContentDataSources.ContentDataSources.BaseRelatedDataSource &  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/ContentDataSources/RelatedContentDataSource as an Item
    */
    export type RelatedContentDataSource_Item = Omit<Item, 'fields'> & RelatedContentDataSource

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/ContentDataSources/RelatedContentDataSource as a Component
    */
    export type RelatedContentDataSource_Component = ComponentProps & RelatedContentDataSource

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/ContentDataSources/RelatedContentDataSource as a Route
    */
    export type RelatedContentDataSource_Route = RouteData & RelatedContentDataSource

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Legacy/ContentDataSources/RelatedContentDataSource
    */
    export type RelatedContentDataSourceJson = FoundationGMILegacyContentDataSources.ContentDataSources.ContentDataSourceBaseJson & 
FoundationGMILegacyContentDataSources.ContentDataSources.FilterableDataSourceJson & 
FoundationGMILegacyContentDataSources.ContentDataSources.SortableDataSourceJson & 
FoundationGMILegacyContentDataSources.ContentDataSources.BaseRelatedDataSourceJson &  {
        

    }
}
export namespace Legacy.SearchNx {

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/SearchNx/Search Configuration
    */
    export type SearchConfiguration =  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/SearchNx/Search Configuration as an Item
    */
    export type SearchConfiguration_Item = Omit<Item, 'fields'> & SearchConfiguration

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/SearchNx/Search Configuration as a Component
    */
    export type SearchConfiguration_Component = ComponentProps & SearchConfiguration

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/SearchNx/Search Configuration as a Route
    */
    export type SearchConfiguration_Route = RouteData & SearchConfiguration

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Legacy/SearchNx/Search Configuration
    */
    export type SearchConfigurationJson =  {
        

    }
}
export namespace Legacy.ContentDataSources {

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/ContentDataSources/SearchContentDataSource
    */
    export type SearchContentDataSource = FoundationGMILegacyContentDataSources.ContentDataSources.ContentDataSourceBase & 
FoundationGMILegacyContentDataSources.ContentDataSources.FilterableDataSource & 
FoundationGMILegacyContentDataSources.ContentDataSources.SortableDataSource & 
FoundationGMILegacyContentDataSources.ContentDataSources.BaseSearchDataSource &  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/ContentDataSources/SearchContentDataSource as an Item
    */
    export type SearchContentDataSource_Item = Omit<Item, 'fields'> & SearchContentDataSource

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/ContentDataSources/SearchContentDataSource as a Component
    */
    export type SearchContentDataSource_Component = ComponentProps & SearchContentDataSource

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/ContentDataSources/SearchContentDataSource as a Route
    */
    export type SearchContentDataSource_Route = RouteData & SearchContentDataSource

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Legacy/ContentDataSources/SearchContentDataSource
    */
    export type SearchContentDataSourceJson = FoundationGMILegacyContentDataSources.ContentDataSources.ContentDataSourceBaseJson & 
FoundationGMILegacyContentDataSources.ContentDataSources.FilterableDataSourceJson & 
FoundationGMILegacyContentDataSources.ContentDataSources.SortableDataSourceJson & 
FoundationGMILegacyContentDataSources.ContentDataSources.BaseSearchDataSourceJson &  {
        
        

    }
}
export namespace Data.Settings {

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Settings/Seo Settings
    */
    export type SeoSettings =  {
        fields?: { 
            /**
            * Represents the Address Country field (f17420fa-c769-4303-899b-5f1d10c8f6ab).
            */
            addressCountry?: Field<string>;

            /**
            * Represents the Address Locality field (d8fb0983-7e2d-4bc5-afa7-101c1f02d47b).
            */
            addressLocality?: Field<string>;

            /**
            * Represents the Address Region field (10538a22-6c13-4ab6-b01c-da6eabcf876f).
            */
            addressRegion?: Field<string>;

            /**
            * Represents the Alternate name(s) - each name to be put in new line in case of multiple names field (980eff11-da3b-4908-a977-091e3cab5262).
            */
            alternateName?: Field<string>;

            /**
            * Represents the Select Article Content Types (this content types will have Article Schema on the page) field (9a36c3df-333e-4855-8d9c-dc7be61a1146).
            */
            articleContentTypes?: Item[];

            /**
            * Represents the Contact Point field (95a7f70e-c328-455d-81fd-62723ad14046).
            */
            contactPoint?: Field<string>;

            /**
            * Represents the Description field (84f3823f-c9f2-49e0-86fe-00efdc6b9913).
            */
            description?: Field<string>;

            /**
            * Represents the Founder field (7e4d8405-1398-450d-8e5b-e542f84c5e79).
            */
            founder?: Field<string>;

            /**
            * Represents the Founding Date field (02928ff5-a89f-476a-ab2e-b3f372e4106a).
            */
            foundingDate?: Field<string>;

            /**
            * Represents the Legal Name field (9c411421-62b5-4d95-828d-1a1fadc83f27).
            */
            legalName?: Field<string>;

            /**
            * Represents the Logo field (6b537433-1ac3-4608-ae89-f0d97d3603ac).
            */
            logo?: Field<string>;

            /**
            * Represents the Name field (80f816fd-8aa5-4303-8109-c28733638977).
            */
            name?: Field<string>;

            /**
            * Represents the Parent Organization field (37db0da7-e37c-4c0c-a2a0-78cfc4548714).
            */
            parentOrganization?: Field<string>;

            /**
            * Represents the Postal Code field (f27041d9-8aaf-4b65-a39a-8a6ac02da21f).
            */
            postalCode?: Field<string>;

            /**
            * Represents the Same As - Each entry to be entered as a new line in case of multiple entries field (a2ca7dcc-661c-44df-82a4-c95e3a0212b2).
            */
            sameAs?: Field<string>;

            /**
            * Represents the Slogan field (1003df82-295c-4a43-998b-d66f35390fe1).
            */
            slogan?: Field<string>;

            /**
            * Represents the Street Address field (2cbc3973-fd73-4a29-9a14-805762e74d11).
            */
            streetAddress?: Field<string>;

            /**
            * Represents the URL field (45e542ee-59db-479d-8e75-ad0817042fa6).
            */
            url?: Field<string>;
        }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Settings/Seo Settings as an Item
    */
    export type SeoSettings_Item = Omit<Item, 'fields'> & SeoSettings

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Settings/Seo Settings as a Component
    */
    export type SeoSettings_Component = ComponentProps & SeoSettings

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Settings/Seo Settings as a Route
    */
    export type SeoSettings_Route = RouteData & SeoSettings

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Data/Settings/Seo Settings
    */
    export type SeoSettingsJson =  {
        
            /**
            * Represents the Address Country field (f17420fa-c769-4303-899b-5f1d10c8f6ab).
            */
            addressCountry?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Address Locality field (d8fb0983-7e2d-4bc5-afa7-101c1f02d47b).
            */
            addressLocality?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Address Region field (10538a22-6c13-4ab6-b01c-da6eabcf876f).
            */
            addressRegion?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Alternate name(s) - each name to be put in new line in case of multiple names field (980eff11-da3b-4908-a977-091e3cab5262).
            */
            alternateName?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Select Article Content Types (this content types will have Article Schema on the page) field (9a36c3df-333e-4855-8d9c-dc7be61a1146).
            */
            articleContentTypes?: {
                jsonValue: Item[]
            };

            /**
            * Represents the Contact Point field (95a7f70e-c328-455d-81fd-62723ad14046).
            */
            contactPoint?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Description field (84f3823f-c9f2-49e0-86fe-00efdc6b9913).
            */
            description?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Founder field (7e4d8405-1398-450d-8e5b-e542f84c5e79).
            */
            founder?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Founding Date field (02928ff5-a89f-476a-ab2e-b3f372e4106a).
            */
            foundingDate?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Legal Name field (9c411421-62b5-4d95-828d-1a1fadc83f27).
            */
            legalName?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Logo field (6b537433-1ac3-4608-ae89-f0d97d3603ac).
            */
            logo?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Name field (80f816fd-8aa5-4303-8109-c28733638977).
            */
            name?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Parent Organization field (37db0da7-e37c-4c0c-a2a0-78cfc4548714).
            */
            parentOrganization?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Postal Code field (f27041d9-8aaf-4b65-a39a-8a6ac02da21f).
            */
            postalCode?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Same As - Each entry to be entered as a new line in case of multiple entries field (a2ca7dcc-661c-44df-82a4-c95e3a0212b2).
            */
            sameAs?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Slogan field (1003df82-295c-4a43-998b-d66f35390fe1).
            */
            slogan?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Street Address field (2cbc3973-fd73-4a29-9a14-805762e74d11).
            */
            streetAddress?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the URL field (45e542ee-59db-479d-8e75-ad0817042fa6).
            */
            url?: {
                jsonValue: Field<string>
            };


    }
}
export namespace Data.Content {

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Content/Share Action Tool Bar Button
    */
    export type ShareActionToolBarButton = FoundationGMIDataContent.Content.ActionToolBarButton &  {
        fields?: { 
            /**
            * Represents the Action Buttons field (f821ef77-176f-4806-8491-43dbba67583e).
            */
            actionButtons?: Item[];
        }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Content/Share Action Tool Bar Button as an Item
    */
    export type ShareActionToolBarButton_Item = Omit<Item, 'fields'> & ShareActionToolBarButton

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Content/Share Action Tool Bar Button as a Component
    */
    export type ShareActionToolBarButton_Component = ComponentProps & ShareActionToolBarButton

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Content/Share Action Tool Bar Button as a Route
    */
    export type ShareActionToolBarButton_Route = RouteData & ShareActionToolBarButton

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Data/Content/Share Action Tool Bar Button
    */
    export type ShareActionToolBarButtonJson = FoundationGMIDataContent.Content.ActionToolBarButtonJson &  {
        
            /**
            * Represents the Action Buttons field (f821ef77-176f-4806-8491-43dbba67583e).
            */
            actionButtons?: {
                jsonValue: Item[]
            };


    }
}
export namespace Site {

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Site/Site Domain
    */
    export type SiteDomain = FoundationGMIBase.BaseData &  {
        fields?: { 
            /**
            * Represents the Default Locale field (12d70704-2eab-423b-8d1e-b6519531cd88).
            */
            defaultLocale?: Item;

            /**
            * Represents the Domain field (feab0e59-7149-4972-bc20-38e7836109c7).
            */
            domain?: Field<string>;

            /**
            * Represents the Other Locales field (f4a92e2c-7519-4d53-8c37-a3b2bd53ac03).
            */
            otherLocales?: Item[];

            /**
            * Represents the Other Preview Domain Locales field (40c17d60-a331-446c-90fc-ce2d6e44cc6e).
            */
            otherPreviewLocales?: Item[];

            /**
            * Represents the Preview Domain field (e4b90a84-0788-41bb-9980-bb5fd8e624a8).
            */
            previewDomain?: Field<string>;

            /**
            * Represents the Region Selector Domain (Primary - Eg: xyz.com or xyz.com/en-IN)   field (a0948473-d03c-47d7-887b-380c4e9793a7).
            */
            regionSelectorDomain?: Field<string>;

            /**
            * Represents the Region Selector Domain Secondary (Empty will fallback to primaryDomain/otherLocale as selected above) field (8694c371-ae93-4cd1-b7f5-7a36a9dd1f79).
            */
            regionSelectorDomainSecondary?: Field<string>;
        }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Site/Site Domain as an Item
    */
    export type SiteDomain_Item = Omit<Item, 'fields'> & SiteDomain

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Site/Site Domain as a Component
    */
    export type SiteDomain_Component = ComponentProps & SiteDomain

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Site/Site Domain as a Route
    */
    export type SiteDomain_Route = RouteData & SiteDomain

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Site/Site Domain
    */
    export type SiteDomainJson = FoundationGMIBase.BaseDataJson &  {
        
            /**
            * Represents the Default Locale field (12d70704-2eab-423b-8d1e-b6519531cd88).
            */
            defaultLocale?: {
                jsonValue: Item
            };

            /**
            * Represents the Domain field (feab0e59-7149-4972-bc20-38e7836109c7).
            */
            domain?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Other Locales field (f4a92e2c-7519-4d53-8c37-a3b2bd53ac03).
            */
            otherLocales?: {
                jsonValue: Item[]
            };

            /**
            * Represents the Other Preview Domain Locales field (40c17d60-a331-446c-90fc-ce2d6e44cc6e).
            */
            otherPreviewLocales?: {
                jsonValue: Item[]
            };

            /**
            * Represents the Preview Domain field (e4b90a84-0788-41bb-9980-bb5fd8e624a8).
            */
            previewDomain?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Region Selector Domain (Primary - Eg: xyz.com or xyz.com/en-IN)   field (a0948473-d03c-47d7-887b-380c4e9793a7).
            */
            regionSelectorDomain?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Region Selector Domain Secondary (Empty will fallback to primaryDomain/otherLocale as selected above) field (8694c371-ae93-4cd1-b7f5-7a36a9dd1f79).
            */
            regionSelectorDomainSecondary?: {
                jsonValue: Field<string>
            };


    }
}
export namespace Data.Settings {

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Settings/Site Settings
    */
    export type SiteSettings = FoundationGMIBase.BaseData &  {
        fields?: { 
            /**
            * Represents the Article Settings field (637a237e-083f-42c1-9df0-3ee3a4e934c6).
            */
            articleSettings?: Item;

            /**
            * Represents the Badge Settings field (78365553-944a-42df-8f9c-ab746db5ea4b).
            */
            badgeSettings?: Item;

            /**
            * Represents the Bazaar Voice Setting field (b8c1e3aa-393f-4cfd-bd72-175a24c2dfe6).
            */
            bazaarVoiceSetting?: Item;

            /**
            * Represents the Brand Style field (7ed36f00-a2c0-4f18-992e-77e5cf51fd4a).
            */
            brandStyle?: Field<string>;

            /**
            * Represents the Buy Now Settings field (14416651-b9ef-41d4-8651-5c77766978e2).
            */
            buyNowSettings?: Item;

            /**
            * Represents the Content Grid Image field (a04e79c1-1030-4af2-a67c-3d930a57ab1a).
            */
            contentGridSettings?: Item;

            /**
            * Represents the Disable Features Settings field (83a18a40-8d84-4c77-96fa-e29e26ec1f25).
            */
            disableFeaturesSettings?: Item;

            /**
            * Represents the Email Settings field (b04f7518-25a5-44b3-98bc-8fc615dd05d9).
            */
            emailSettings?: Item;

            /**
            * Represents the Default ESRC Code field (d138c316-54c6-468a-9e97-7e50fffac7e4).
            */
            esrcCode?: Field<string>;

            /**
            * Represents the Fav Icon field (cd7504f1-90af-4593-bff9-d7a4e10aa70f).
            */
            favIcon?: ImageField;

            /**
            * Represents the GTM ID field (20e8dc0b-b542-48c9-bfdc-cd27ac60f362).
            */
            gtmId?: Field<string>;

            /**
            * Represents the Login and Registration Settings field (dbb86ac4-9012-4310-8ba3-46235fe81305).
            */
            loginRegistrationSettings?: Item;

            /**
            * Represents the metaDataTagSettings field (0156dca0-41d9-4146-8979-11fa48b5cf06).
            */
            metaDataTagSettings?: Item;

            /**
            * Represents the MyFavouritesIcon field (e1e4a32f-7aff-4457-9651-b99046326f10).
            */
            MyFavouritesIcon?: ImageField;

            /**
            * Represents the newsletterTitle field (8384f3ba-649e-4883-a163-26eaee0c8f0c).
            */
            newsletterTitle?: Field<string>;

            /**
            * Represents the OneTrust Default Consent Preference field (36cb9202-5ff8-4f85-97bb-c9169ca35163).
            */
            oneTrustDefaultConsentPreference?: Field<string>;

            /**
            * Represents the OneTrust Script ID field (9d1e1202-1c58-43fa-b5ae-797bd7e335cc).
            */
            oneTrustScriptID?: Field<string>;

            /**
            * Represents the PresearchItems field (48dd2cd3-faef-4ebd-b808-f5715b1ffbb2).
            */
            PresearchItems?: Field<string>;

            /**
            * Represents the Product Detail Settings field (ac436a63-fe01-4949-b803-ef5c1bdd920d).
            */
            productDetailSettings?: Item;

            /**
            * Represents the Profile Site Identifier field (a5c90aa4-c50f-4d00-b391-44b7cadc6574).
            */
            profileSiteId?: Field<string>;

            /**
            * Represents the Recipe Site Settings field (bd2f088e-021b-469e-83fb-7daa73f73b9c).
            */
            recipeDetailSiteSettings?: Item;

            /**
            * Represents the Search Configuration Id field (459be16f-4ccf-4fa6-94b1-c25ac74e2877).
            */
            searchConfigurationId?: Field<string>;

            /**
            * Represents the Seo Settings field (5fd93e1c-d1a1-4f8e-a0cb-90271534e8dc).
            */
            seoSettings?: Item;

            /**
            * Represents the siteAlert field (4c1e8840-d082-49cd-9c8a-332647e43955).
            */
            siteAlert?: Item;

            /**
            * Represents the Site Logo field (c36d1fc1-926e-45b8-8ca0-69984e6cfff5).
            */
            siteLogo?: ImageField;

            /**
            * Represents the Site Name field (cf45a0e1-0a3b-4486-a56a-da04ae264471).
            */
            siteName?: Field<string>;

            /**
            * Represents the Subscription ID field (d9d0cfb6-a3d0-4d06-8e18-6a785fb1b80d).
            */
            subscriptionID?: Field<string>;
        }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Settings/Site Settings as an Item
    */
    export type SiteSettings_Item = Omit<Item, 'fields'> & SiteSettings

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Settings/Site Settings as a Component
    */
    export type SiteSettings_Component = ComponentProps & SiteSettings

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Settings/Site Settings as a Route
    */
    export type SiteSettings_Route = RouteData & SiteSettings

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Data/Settings/Site Settings
    */
    export type SiteSettingsJson = FoundationGMIBase.BaseDataJson &  {
        
            /**
            * Represents the Article Settings field (637a237e-083f-42c1-9df0-3ee3a4e934c6).
            */
            articleSettings?: {
                jsonValue: Item
            };

            /**
            * Represents the Badge Settings field (78365553-944a-42df-8f9c-ab746db5ea4b).
            */
            badgeSettings?: {
                jsonValue: Item
            };

            /**
            * Represents the Bazaar Voice Setting field (b8c1e3aa-393f-4cfd-bd72-175a24c2dfe6).
            */
            bazaarVoiceSetting?: {
                jsonValue: Item
            };

            /**
            * Represents the Brand Style field (7ed36f00-a2c0-4f18-992e-77e5cf51fd4a).
            */
            brandStyle?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Buy Now Settings field (14416651-b9ef-41d4-8651-5c77766978e2).
            */
            buyNowSettings?: {
                jsonValue: Item
            };

            /**
            * Represents the Content Grid Image field (a04e79c1-1030-4af2-a67c-3d930a57ab1a).
            */
            contentGridSettings?: {
                jsonValue: Item
            };

            /**
            * Represents the Disable Features Settings field (83a18a40-8d84-4c77-96fa-e29e26ec1f25).
            */
            disableFeaturesSettings?: {
                jsonValue: Item
            };

            /**
            * Represents the Email Settings field (b04f7518-25a5-44b3-98bc-8fc615dd05d9).
            */
            emailSettings?: {
                jsonValue: Item
            };

            /**
            * Represents the Default ESRC Code field (d138c316-54c6-468a-9e97-7e50fffac7e4).
            */
            esrcCode?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Fav Icon field (cd7504f1-90af-4593-bff9-d7a4e10aa70f).
            */
            favIcon?: {
                jsonValue: ImageField
            };

            /**
            * Represents the GTM ID field (20e8dc0b-b542-48c9-bfdc-cd27ac60f362).
            */
            gtmId?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Login and Registration Settings field (dbb86ac4-9012-4310-8ba3-46235fe81305).
            */
            loginRegistrationSettings?: {
                jsonValue: Item
            };

            /**
            * Represents the metaDataTagSettings field (0156dca0-41d9-4146-8979-11fa48b5cf06).
            */
            metaDataTagSettings?: {
                jsonValue: Item
            };

            /**
            * Represents the MyFavouritesIcon field (e1e4a32f-7aff-4457-9651-b99046326f10).
            */
            MyFavouritesIcon?: {
                jsonValue: ImageField
            };

            /**
            * Represents the newsletterTitle field (8384f3ba-649e-4883-a163-26eaee0c8f0c).
            */
            newsletterTitle?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the OneTrust Default Consent Preference field (36cb9202-5ff8-4f85-97bb-c9169ca35163).
            */
            oneTrustDefaultConsentPreference?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the OneTrust Script ID field (9d1e1202-1c58-43fa-b5ae-797bd7e335cc).
            */
            oneTrustScriptID?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the PresearchItems field (48dd2cd3-faef-4ebd-b808-f5715b1ffbb2).
            */
            PresearchItems?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Product Detail Settings field (ac436a63-fe01-4949-b803-ef5c1bdd920d).
            */
            productDetailSettings?: {
                jsonValue: Item
            };

            /**
            * Represents the Profile Site Identifier field (a5c90aa4-c50f-4d00-b391-44b7cadc6574).
            */
            profileSiteId?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Recipe Site Settings field (bd2f088e-021b-469e-83fb-7daa73f73b9c).
            */
            recipeDetailSiteSettings?: {
                jsonValue: Item
            };

            /**
            * Represents the Search Configuration Id field (459be16f-4ccf-4fa6-94b1-c25ac74e2877).
            */
            searchConfigurationId?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Seo Settings field (5fd93e1c-d1a1-4f8e-a0cb-90271534e8dc).
            */
            seoSettings?: {
                jsonValue: Item
            };

            /**
            * Represents the siteAlert field (4c1e8840-d082-49cd-9c8a-332647e43955).
            */
            siteAlert?: {
                jsonValue: Item
            };

            /**
            * Represents the Site Logo field (c36d1fc1-926e-45b8-8ca0-69984e6cfff5).
            */
            siteLogo?: {
                jsonValue: ImageField
            };

            /**
            * Represents the Site Name field (cf45a0e1-0a3b-4486-a56a-da04ae264471).
            */
            siteName?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Subscription ID field (d9d0cfb6-a3d0-4d06-8e18-6a785fb1b80d).
            */
            subscriptionID?: {
                jsonValue: Field<string>
            };


    }
}

export namespace Legacy.SearchNx {

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/SearchNx/Timed Release Override
    */
    export type TimedReleaseOverride =  {
        fields?: { 
            /**
            * Represents the CtaText field (2af5f498-9bf6-4bbe-8ac2-5a869c2747c3).
            */
            CtaText?: Field<string>;

            /**
            * Represents the Description field (6ac5683a-438b-4d1f-a712-6b201437f243).
            */
            Description?: Field<string>;

            /**
            * Represents the Image field (2865fbef-6fa8-47cc-b4a9-4073aee140fa).
            */
            Image?: ImageField;

            /**
            * Represents the OverrideContent field (72a287ae-dc86-46a8-a920-aa65fb4e20fd).
            */
            OverrideContent?: Field<string>;

            /**
            * Represents the ReleaseDate field (a1b046e8-492f-4597-bc4b-0ccbfc2ec119).
            */
            ReleaseDate?: TextField;

            /**
            * Represents the RemoveTitleLink field (2e194c23-91d0-4ec1-ac7e-e72f9b4d267e).
            */
            RemoveTitleLink?: Field<boolean>;

            /**
            * Represents the Tag field (5702f0b2-d5bf-494e-9336-82167dc51e46).
            */
            Tag?: Field<string>;

            /**
            * Represents the Title field (ead6514f-354d-429e-92e5-fd18602f858d).
            */
            Title?: Field<string>;

            /**
            * Represents the URL field (0528ea5f-5158-4c9c-899a-643c27be3ced).
            */
            URL?: LinkField;
        }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/SearchNx/Timed Release Override as an Item
    */
    export type TimedReleaseOverride_Item = Omit<Item, 'fields'> & TimedReleaseOverride

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/SearchNx/Timed Release Override as a Component
    */
    export type TimedReleaseOverride_Component = ComponentProps & TimedReleaseOverride

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/SearchNx/Timed Release Override as a Route
    */
    export type TimedReleaseOverride_Route = RouteData & TimedReleaseOverride

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Legacy/SearchNx/Timed Release Override
    */
    export type TimedReleaseOverrideJson =  {
        
            /**
            * Represents the CtaText field (2af5f498-9bf6-4bbe-8ac2-5a869c2747c3).
            */
            CtaText?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Description field (6ac5683a-438b-4d1f-a712-6b201437f243).
            */
            Description?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Image field (2865fbef-6fa8-47cc-b4a9-4073aee140fa).
            */
            Image?: {
                jsonValue: ImageField
            };

            /**
            * Represents the OverrideContent field (72a287ae-dc86-46a8-a920-aa65fb4e20fd).
            */
            OverrideContent?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the ReleaseDate field (a1b046e8-492f-4597-bc4b-0ccbfc2ec119).
            */
            ReleaseDate?: {
                jsonValue: TextField
            };

            /**
            * Represents the RemoveTitleLink field (2e194c23-91d0-4ec1-ac7e-e72f9b4d267e).
            */
            RemoveTitleLink?: {
                jsonValue: Field<boolean>
            };

            /**
            * Represents the Tag field (5702f0b2-d5bf-494e-9336-82167dc51e46).
            */
            Tag?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Title field (ead6514f-354d-429e-92e5-fd18602f858d).
            */
            Title?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the URL field (0528ea5f-5158-4c9c-899a-643c27be3ced).
            */
            URL?: {
                jsonValue: LinkField
            };


    }
}
export namespace Data.Content {

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Content/Video
    */
    export type Video =  {
        fields?: { 
            /**
            * Represents the ContentItems field (99e4cbf6-2206-47c6-8beb-5b2f701a5d38).
            */
            ContentItems?: Field<string>;

            /**
            * Represents the RecipeContentId field (22148b5b-323d-4361-8a48-84664743bc83).
            */
            recipeContentId?: Field<string>;

            /**
            * Represents the Transcript Link field (3f122795-94ac-4c27-9e65-d6a1c494706e).
            */
            textTranscriptLink?: LinkField;

            /**
            * Represents the The text transcript of the video field (6fe9644f-2238-4650-b7cd-901a0d0bc080).
            */
            transcriptText?: Field<string>;

            /**
            * Represents the Upload Date field (d2f2d6d9-74d9-44cf-a3db-30e49534d68b).
            */
            uploadDate?: TextField;

            /**
            * Represents the videoDescription field (a578786c-c2ca-40bf-94c6-8267f7df6c2b).
            */
            videoDescription?: Field<string>;

            /**
            * Represents the videoHeadline field (beac7486-5664-4732-8200-54a88e81f229).
            */
            videoHeadline?: Field<string>;

            /**
            * Represents the The ID of a video (e.g. YouTube Video).  Whenever this video is rendered, this transcript will be used field (c04a2b93-f72c-40c8-99fa-05fedd2f8d97).
            */
            videoId?: Field<string>;

            /**
            * Represents the Video Thumbnail field (6fcdca37-f08e-4818-87fc-ee0353b5be7a).
            */
            videoThumbnail?: ImageField;

            /**
            * Represents the VideoThumbnailExternal field (120578db-7161-4aaa-a6ae-39be4bfe434d).
            */
            videoThumbnailExternal?: LinkField;

            /**
            * Represents the Video Type field (6ec47a61-8868-48d0-a5b2-b95f2f11581d).
            */
            videoType?: Field<string>;

            /**
            * Represents the Video URL field (e56c970a-8b08-47c1-8302-2f488b0d80a5).
            */
            videoURL?: Field<string>;

            /**
            * Represents the Video with Audio Description URL: A URL for a second video that includes voice over for for visually impaired people field (20d948cc-02f4-4912-b3ae-4aade3b3bd4b).
            */
            videoWithAudioDescriptionURL?: Field<string>;
        }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Content/Video as an Item
    */
    export type Video_Item = Omit<Item, 'fields'> & Video

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Content/Video as a Component
    */
    export type Video_Component = ComponentProps & Video

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Content/Video as a Route
    */
    export type Video_Route = RouteData & Video

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Data/Content/Video
    */
    export type VideoJson =  {
        
            /**
            * Represents the ContentItems field (99e4cbf6-2206-47c6-8beb-5b2f701a5d38).
            */
            ContentItems?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the RecipeContentId field (22148b5b-323d-4361-8a48-84664743bc83).
            */
            recipeContentId?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Transcript Link field (3f122795-94ac-4c27-9e65-d6a1c494706e).
            */
            textTranscriptLink?: {
                jsonValue: LinkField
            };

            /**
            * Represents the The text transcript of the video field (6fe9644f-2238-4650-b7cd-901a0d0bc080).
            */
            transcriptText?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Upload Date field (d2f2d6d9-74d9-44cf-a3db-30e49534d68b).
            */
            uploadDate?: {
                jsonValue: TextField
            };

            /**
            * Represents the videoDescription field (a578786c-c2ca-40bf-94c6-8267f7df6c2b).
            */
            videoDescription?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the videoHeadline field (beac7486-5664-4732-8200-54a88e81f229).
            */
            videoHeadline?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the The ID of a video (e.g. YouTube Video).  Whenever this video is rendered, this transcript will be used field (c04a2b93-f72c-40c8-99fa-05fedd2f8d97).
            */
            videoId?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Video Thumbnail field (6fcdca37-f08e-4818-87fc-ee0353b5be7a).
            */
            videoThumbnail?: {
                jsonValue: ImageField
            };

            /**
            * Represents the VideoThumbnailExternal field (120578db-7161-4aaa-a6ae-39be4bfe434d).
            */
            videoThumbnailExternal?: {
                jsonValue: LinkField
            };

            /**
            * Represents the Video Type field (6ec47a61-8868-48d0-a5b2-b95f2f11581d).
            */
            videoType?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Video URL field (e56c970a-8b08-47c1-8302-2f488b0d80a5).
            */
            videoURL?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Video with Audio Description URL: A URL for a second video that includes voice over for for visually impaired people field (20d948cc-02f4-4912-b3ae-4aade3b3bd4b).
            */
            videoWithAudioDescriptionURL?: {
                jsonValue: Field<string>
            };


    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Content/Video Folder
    */
    export type VideoFolder =  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Content/Video Folder as an Item
    */
    export type VideoFolder_Item = Omit<Item, 'fields'> & VideoFolder

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Content/Video Folder as a Component
    */
    export type VideoFolder_Component = ComponentProps & VideoFolder

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/Content/Video Folder as a Route
    */
    export type VideoFolder_Route = RouteData & VideoFolder

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Data/Content/Video Folder
    */
    export type VideoFolderJson =  {
        

    }
}
export namespace Base {

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/_BaseComponent
    */
    export type BaseComponent =  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/_BaseComponent as an Item
    */
    export type BaseComponent_Item = Omit<Item, 'fields'> & BaseComponent

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/_BaseComponent as a Component
    */
    export type BaseComponent_Component = ComponentProps & BaseComponent

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/_BaseComponent as a Route
    */
    export type BaseComponent_Route = RouteData & BaseComponent

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Base/_BaseComponent
    */
    export type BaseComponentJson =  {
        

    }
}
export namespace Base.RenderingParameters {

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/Rendering Parameters/_BaseComponentLayout
    */
    export type BaseComponentLayout =  {
        fields?: { 
            /**
            * Represents the Constrained Component Width field (e43528b7-cc21-425f-ab9b-610df1953598).
            */
            constrainedComponentWidth?: Field<boolean>;
        }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/Rendering Parameters/_BaseComponentLayout as an Item
    */
    export type BaseComponentLayout_Item = Omit<Item, 'fields'> & BaseComponentLayout

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/Rendering Parameters/_BaseComponentLayout as a Component
    */
    export type BaseComponentLayout_Component = ComponentProps & BaseComponentLayout

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/Rendering Parameters/_BaseComponentLayout as a Route
    */
    export type BaseComponentLayout_Route = RouteData & BaseComponentLayout

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Base/Rendering Parameters/_BaseComponentLayout
    */
    export type BaseComponentLayoutJson =  {
        
            /**
            * Represents the Constrained Component Width field (e43528b7-cc21-425f-ab9b-610df1953598).
            */
            constrainedComponentWidth?: {
                jsonValue: Field<boolean>
            };


    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/Rendering Parameters/_BaseComponentParameters
    */
    export type BaseComponentParameters =  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/Rendering Parameters/_BaseComponentParameters as an Item
    */
    export type BaseComponentParameters_Item = Omit<Item, 'fields'> & BaseComponentParameters

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/Rendering Parameters/_BaseComponentParameters as a Component
    */
    export type BaseComponentParameters_Component = ComponentProps & BaseComponentParameters

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/Rendering Parameters/_BaseComponentParameters as a Route
    */
    export type BaseComponentParameters_Route = RouteData & BaseComponentParameters

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Base/Rendering Parameters/_BaseComponentParameters
    */
    export type BaseComponentParametersJson =  {
        

    }
}
export namespace Base.PageFields {

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/PageFields/_BaseContent
    */
    export type BaseContent =  {
        fields?: { 
            /**
            * Represents the Author Selection field (c92dedd5-bdb2-469d-9f43-7b0735588a88).
            */
            authorSelection?: Item;

            /**
            * Represents the Canonical URL Override field (809d427f-3236-4195-b5c1-adf3ef99e299).
            */
            canonicalUrlOverride?: Field<string>;

            /**
            * Represents the Content Description field (f5b49247-fb4e-46a1-b7d5-0d1ef506f2ce).
            */
            contentDescription?: Field<string>;

            /**
            * Represents the Content Eyebrow field (8a80ffae-d431-4448-8cb7-e5d144dd5b20).
            */
            contentEyebrow?: Field<string>;

            /**
            * Represents the Content Headline field (84b38e10-4187-4f46-8254-fe59ce5348f5).
            */
            contentHeadline?: Field<string>;

            /**
            * Represents the Page Image field (df48056e-99e1-40dd-b82a-b0dcb8622055).
            */
            contentPageImage?: ImageField;

            /**
            * Represents the Primary CTA field (2d617655-020a-4ccc-8248-0fdcc2343232).
            */
            contentPrimaryCta?: LinkField;

            /**
            * Represents the Secondary CTA field (20e6599c-0869-4d4b-affc-a60e01e72ee6).
            */
            contentSecondaryCta?: LinkField;

            /**
            * Represents the External Image Alternate Text field (4219e1fa-1f7c-4912-a94b-9db307884f02).
            */
            externalImageAlternateText?: Field<string>;

            /**
            * Represents the External Page Image field (1080caf8-003f-4da0-bfd5-efa2de8e7a3d).
            */
            externalPageImage?: LinkField;

            /**
            * Represents the Hide this page from breadcrumb? field (b2a5b827-f40c-47eb-8d76-f92751a448b9).
            */
            hideFromBreadcrumb?: Field<boolean>;

            /**
            * Represents the Navigation Title field (ee2e5ba8-53f7-44cd-a8f4-b47868f64451).
            */
            navigationTitleOverride?: Field<string>;

            /**
            * Represents the Pre-Search Icon field (3c5ab360-04b8-4fc3-8f56-a03b131eceed).
            */
            preSearchIcon?: ImageField;

            /**
            * Represents the Pre-Search Title Override field (a7242532-5723-45e5-9657-351e92ce9431).
            */
            preSearchTitleOverride?: Field<string>;

            /**
            * Represents the Robots Meta - No Follow field (633a4366-322b-46aa-98c8-db08ac323470).
            */
            robotsNoFollow?: Field<boolean>;

            /**
            * Represents the Robots Meta - No Index field (8b3d529f-f4b1-4f64-922f-50ef420ee6ff).
            */
            robotsNoIndex?: Field<boolean>;

            /**
            * Represents the Search Page Image Override field (fe199f61-85af-47c5-845f-26b21934e129).
            */
            searchPageImageOverride?: ImageField;

            /**
            * Represents the Search Title Override field (1bc50226-755b-48f6-b309-64c21af94b46).
            */
            searchTitleOverride?: Field<string>;

            /**
            * Represents the SEO Meta Description field (64a73548-0786-4e8e-a93c-170626e7ccc8).
            */
            seoMetaDescription?: Field<string>;

            /**
            * Represents the SEO Page Title field (7b67fa66-efb2-4d7d-b71e-1c4940710cb1).
            */
            seoPageTitle?: Field<string>;
        }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/PageFields/_BaseContent as an Item
    */
    export type BaseContent_Item = Omit<Item, 'fields'> & BaseContent

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/PageFields/_BaseContent as a Component
    */
    export type BaseContent_Component = ComponentProps & BaseContent

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/PageFields/_BaseContent as a Route
    */
    export type BaseContent_Route = RouteData & BaseContent

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Base/PageFields/_BaseContent
    */
    export type BaseContentJson =  {
        
            /**
            * Represents the Author Selection field (c92dedd5-bdb2-469d-9f43-7b0735588a88).
            */
            authorSelection?: {
                jsonValue: Item
            };

            /**
            * Represents the Canonical URL Override field (809d427f-3236-4195-b5c1-adf3ef99e299).
            */
            canonicalUrlOverride?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Content Description field (f5b49247-fb4e-46a1-b7d5-0d1ef506f2ce).
            */
            contentDescription?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Content Eyebrow field (8a80ffae-d431-4448-8cb7-e5d144dd5b20).
            */
            contentEyebrow?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Content Headline field (84b38e10-4187-4f46-8254-fe59ce5348f5).
            */
            contentHeadline?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Page Image field (df48056e-99e1-40dd-b82a-b0dcb8622055).
            */
            contentPageImage?: {
                jsonValue: ImageField
            };

            /**
            * Represents the Primary CTA field (2d617655-020a-4ccc-8248-0fdcc2343232).
            */
            contentPrimaryCta?: {
                jsonValue: LinkField
            };

            /**
            * Represents the Secondary CTA field (20e6599c-0869-4d4b-affc-a60e01e72ee6).
            */
            contentSecondaryCta?: {
                jsonValue: LinkField
            };

            /**
            * Represents the External Image Alternate Text field (4219e1fa-1f7c-4912-a94b-9db307884f02).
            */
            externalImageAlternateText?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the External Page Image field (1080caf8-003f-4da0-bfd5-efa2de8e7a3d).
            */
            externalPageImage?: {
                jsonValue: LinkField
            };

            /**
            * Represents the Hide this page from breadcrumb? field (b2a5b827-f40c-47eb-8d76-f92751a448b9).
            */
            hideFromBreadcrumb?: {
                jsonValue: Field<boolean>
            };

            /**
            * Represents the Navigation Title field (ee2e5ba8-53f7-44cd-a8f4-b47868f64451).
            */
            navigationTitleOverride?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Pre-Search Icon field (3c5ab360-04b8-4fc3-8f56-a03b131eceed).
            */
            preSearchIcon?: {
                jsonValue: ImageField
            };

            /**
            * Represents the Pre-Search Title Override field (a7242532-5723-45e5-9657-351e92ce9431).
            */
            preSearchTitleOverride?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Robots Meta - No Follow field (633a4366-322b-46aa-98c8-db08ac323470).
            */
            robotsNoFollow?: {
                jsonValue: Field<boolean>
            };

            /**
            * Represents the Robots Meta - No Index field (8b3d529f-f4b1-4f64-922f-50ef420ee6ff).
            */
            robotsNoIndex?: {
                jsonValue: Field<boolean>
            };

            /**
            * Represents the Search Page Image Override field (fe199f61-85af-47c5-845f-26b21934e129).
            */
            searchPageImageOverride?: {
                jsonValue: ImageField
            };

            /**
            * Represents the Search Title Override field (1bc50226-755b-48f6-b309-64c21af94b46).
            */
            searchTitleOverride?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the SEO Meta Description field (64a73548-0786-4e8e-a93c-170626e7ccc8).
            */
            seoMetaDescription?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the SEO Page Title field (7b67fa66-efb2-4d7d-b71e-1c4940710cb1).
            */
            seoPageTitle?: {
                jsonValue: Field<string>
            };


    }
}
export namespace Base {

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/_BaseData
    */
    export type BaseData =  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/_BaseData as an Item
    */
    export type BaseData_Item = Omit<Item, 'fields'> & BaseData

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/_BaseData as a Component
    */
    export type BaseData_Component = ComponentProps & BaseData

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/_BaseData as a Route
    */
    export type BaseData_Route = RouteData & BaseData

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Base/_BaseData
    */
    export type BaseDataJson =  {
        

    }
}
export namespace Base.RenderingParameters {

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/Rendering Parameters/_BaseGridCardParameters
    */
    export type BaseGridCardParameters =  {
        fields?: { 
            /**
            * Represents the Card Content Alignment field (1c75fdf7-abcd-48ef-9c86-c3d05c7eb5ed).
            */
            cardAlignment?: Field<string>;

            /**
            * Represents the Grid Image Aspect Ratio field (2b6a7028-0b81-4c0d-ae85-2a90128bc63a).
            */
            gridAspectRatio?: Item;
        }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/Rendering Parameters/_BaseGridCardParameters as an Item
    */
    export type BaseGridCardParameters_Item = Omit<Item, 'fields'> & BaseGridCardParameters

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/Rendering Parameters/_BaseGridCardParameters as a Component
    */
    export type BaseGridCardParameters_Component = ComponentProps & BaseGridCardParameters

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/Rendering Parameters/_BaseGridCardParameters as a Route
    */
    export type BaseGridCardParameters_Route = RouteData & BaseGridCardParameters

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Base/Rendering Parameters/_BaseGridCardParameters
    */
    export type BaseGridCardParametersJson =  {
        
            /**
            * Represents the Card Content Alignment field (1c75fdf7-abcd-48ef-9c86-c3d05c7eb5ed).
            */
            cardAlignment?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Grid Image Aspect Ratio field (2b6a7028-0b81-4c0d-ae85-2a90128bc63a).
            */
            gridAspectRatio?: {
                jsonValue: Item
            };


    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/Rendering Parameters/_BaseGridParameters
    */
    export type BaseGridParameters =  {
        fields?: { 
            /**
            * Represents the Center Last Row field (c1524cb2-a412-45f9-a294-580559077a1e).
            */
            centerLastRow?: Field<boolean>;
        }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/Rendering Parameters/_BaseGridParameters as an Item
    */
    export type BaseGridParameters_Item = Omit<Item, 'fields'> & BaseGridParameters

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/Rendering Parameters/_BaseGridParameters as a Component
    */
    export type BaseGridParameters_Component = ComponentProps & BaseGridParameters

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/Rendering Parameters/_BaseGridParameters as a Route
    */
    export type BaseGridParameters_Route = RouteData & BaseGridParameters

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Base/Rendering Parameters/_BaseGridParameters
    */
    export type BaseGridParametersJson =  {
        
            /**
            * Represents the Center Last Row field (c1524cb2-a412-45f9-a294-580559077a1e).
            */
            centerLastRow?: {
                jsonValue: Field<boolean>
            };


    }
}
export namespace Base.ComponentFields.Combos {

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/ComponentFields/Combos/_BaseHeadlineBasic
    */
    export type BaseHeadlineBasic = FoundationGMIBaseComponentFields.ComponentFields.HeadlineFields.HeadlineField &  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/ComponentFields/Combos/_BaseHeadlineBasic as an Item
    */
    export type BaseHeadlineBasic_Item = Omit<Item, 'fields'> & BaseHeadlineBasic

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/ComponentFields/Combos/_BaseHeadlineBasic as a Component
    */
    export type BaseHeadlineBasic_Component = ComponentProps & BaseHeadlineBasic

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/ComponentFields/Combos/_BaseHeadlineBasic as a Route
    */
    export type BaseHeadlineBasic_Route = RouteData & BaseHeadlineBasic

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Base/ComponentFields/Combos/_BaseHeadlineBasic
    */
    export type BaseHeadlineBasicJson = FoundationGMIBaseComponentFields.ComponentFields.HeadlineFields.HeadlineFieldJson &  {
        

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/ComponentFields/Combos/_BaseHeadlineStandard
    */
    export type BaseHeadlineStandard = FoundationGMIBaseComponentFields.ComponentFields.HeadlineFields.HeadlineField & 
FoundationGMIBaseComponentFields.ComponentFields.HeadlineFields.HeadlineEyebrowField & 
FoundationGMIBaseComponentFields.ComponentFields.HeadlineFields.HeadlineSubheadField &  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/ComponentFields/Combos/_BaseHeadlineStandard as an Item
    */
    export type BaseHeadlineStandard_Item = Omit<Item, 'fields'> & BaseHeadlineStandard

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/ComponentFields/Combos/_BaseHeadlineStandard as a Component
    */
    export type BaseHeadlineStandard_Component = ComponentProps & BaseHeadlineStandard

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/ComponentFields/Combos/_BaseHeadlineStandard as a Route
    */
    export type BaseHeadlineStandard_Route = RouteData & BaseHeadlineStandard

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Base/ComponentFields/Combos/_BaseHeadlineStandard
    */
    export type BaseHeadlineStandardJson = FoundationGMIBaseComponentFields.ComponentFields.HeadlineFields.HeadlineFieldJson & 
FoundationGMIBaseComponentFields.ComponentFields.HeadlineFields.HeadlineEyebrowFieldJson & 
FoundationGMIBaseComponentFields.ComponentFields.HeadlineFields.HeadlineSubheadFieldJson &  {
        

    }
}
export namespace Legacy.ContentDataSources {

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/ContentDataSources/_BaseMetaDataSource
    */
    export type BaseMetaDataSource =  {
        fields?: { 
            /**
            * Represents the Only include results that match every tag selected? field (b6dae54c-9f99-48ae-908e-c534d1b53f58).
            */
            MatchAllTags?: Field<boolean>;

            /**
            * Represents the MetadataServiceTags field (b5072c74-d99f-4a28-bc2a-f10880be7961).
            */
            MetadataServiceTags?: Field<string>;
        }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/ContentDataSources/_BaseMetaDataSource as an Item
    */
    export type BaseMetaDataSource_Item = Omit<Item, 'fields'> & BaseMetaDataSource

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/ContentDataSources/_BaseMetaDataSource as a Component
    */
    export type BaseMetaDataSource_Component = ComponentProps & BaseMetaDataSource

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/ContentDataSources/_BaseMetaDataSource as a Route
    */
    export type BaseMetaDataSource_Route = RouteData & BaseMetaDataSource

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Legacy/ContentDataSources/_BaseMetaDataSource
    */
    export type BaseMetaDataSourceJson =  {
        
            /**
            * Represents the Only include results that match every tag selected? field (b6dae54c-9f99-48ae-908e-c534d1b53f58).
            */
            MatchAllTags?: {
                jsonValue: Field<boolean>
            };

            /**
            * Represents the MetadataServiceTags field (b5072c74-d99f-4a28-bc2a-f10880be7961).
            */
            MetadataServiceTags?: {
                jsonValue: Field<string>
            };


    }
}
export namespace Base {

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/_BasePage
    */
    export type BasePage = FoundationGMIBasePageFields.PageFields.BaseContent & 
FoundationGMIBasePageFields.PageFields.PageDetails & 
FoundationGMIBasePageFields.PageFields.PageTechnicalDetails & 
FoundationGMIBasePageFields.PageFields.pageComponents &  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/_BasePage as an Item
    */
    export type BasePage_Item = Omit<Item, 'fields'> & BasePage

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/_BasePage as a Component
    */
    export type BasePage_Component = ComponentProps & BasePage

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/_BasePage as a Route
    */
    export type BasePage_Route = RouteData & BasePage

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Base/_BasePage
    */
    export type BasePageJson = FoundationGMIBasePageFields.PageFields.BaseContentJson & 
FoundationGMIBasePageFields.PageFields.PageDetailsJson & 
FoundationGMIBasePageFields.PageFields.PageTechnicalDetailsJson & 
FoundationGMIBasePageFields.PageFields.pageComponentsJson &  {
        

    }
}
export namespace Data.UserProfile {

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/UserProfile/_BasePassword
    */
    export type BasePassword =  {
        fields?: { 
            /**
            * Represents the Confirm Password Label field (1d32e795-dcd1-4968-aeae-cc9373ac5d3c).
            */
            confirmPasswordLabel?: Field<string>;

            /**
            * Represents the Save Button Label field (c2576971-d251-488a-bc24-dcc35dd4adec).
            */
            passwordCTALabel?: Field<string>;

            /**
            * Represents the New Password Label field (6d62f5c0-1af7-4a00-966b-cb7ba7a7158b).
            */
            passwordLabel?: Field<string>;
        }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/UserProfile/_BasePassword as an Item
    */
    export type BasePassword_Item = Omit<Item, 'fields'> & BasePassword

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/UserProfile/_BasePassword as a Component
    */
    export type BasePassword_Component = ComponentProps & BasePassword

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/UserProfile/_BasePassword as a Route
    */
    export type BasePassword_Route = RouteData & BasePassword

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Data/UserProfile/_BasePassword
    */
    export type BasePasswordJson =  {
        
            /**
            * Represents the Confirm Password Label field (1d32e795-dcd1-4968-aeae-cc9373ac5d3c).
            */
            confirmPasswordLabel?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Save Button Label field (c2576971-d251-488a-bc24-dcc35dd4adec).
            */
            passwordCTALabel?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the New Password Label field (6d62f5c0-1af7-4a00-966b-cb7ba7a7158b).
            */
            passwordLabel?: {
                jsonValue: Field<string>
            };


    }
}
export namespace Base.ComponentFields {

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/ComponentFields/_BasePreamble
    */
    export type BasePreamble = FoundationGMIBaseComponentFields.ComponentFields.Combos.BaseHeadlineStandard & 
FoundationGMIBaseComponentFields.ComponentFields.HeadlineFields.HeadlineDescriptionField & 
FoundationGMIBaseComponentFields.ComponentFields.CtaFields.Cta1Field & 
FoundationGMIBaseComponentFields.ComponentFields.CtaFields.Cta2Field & 
FoundationGMIBaseComponentFields.ComponentFields.HeadlineFields.HeadlineIconField &  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/ComponentFields/_BasePreamble as an Item
    */
    export type BasePreamble_Item = Omit<Item, 'fields'> & BasePreamble

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/ComponentFields/_BasePreamble as a Component
    */
    export type BasePreamble_Component = ComponentProps & BasePreamble

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/ComponentFields/_BasePreamble as a Route
    */
    export type BasePreamble_Route = RouteData & BasePreamble

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Base/ComponentFields/_BasePreamble
    */
    export type BasePreambleJson = FoundationGMIBaseComponentFields.ComponentFields.Combos.BaseHeadlineStandardJson & 
FoundationGMIBaseComponentFields.ComponentFields.HeadlineFields.HeadlineDescriptionFieldJson & 
FoundationGMIBaseComponentFields.ComponentFields.CtaFields.Cta1FieldJson & 
FoundationGMIBaseComponentFields.ComponentFields.CtaFields.Cta2FieldJson & 
FoundationGMIBaseComponentFields.ComponentFields.HeadlineFields.HeadlineIconFieldJson &  {
        

    }
}
export namespace Base.RenderingParameters {

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/Rendering Parameters/_BasePreambleParametersOrientationAll
    */
    export type BasePreambleParametersOrientationAll =  {
        fields?: { 
            /**
            * Represents the Preamble Orientation field (c1481194-412a-4dc8-a84e-a3b64c1260b6).
            */
            preambleOrientation?: Field<string>;
        }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/Rendering Parameters/_BasePreambleParametersOrientationAll as an Item
    */
    export type BasePreambleParametersOrientationAll_Item = Omit<Item, 'fields'> & BasePreambleParametersOrientationAll

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/Rendering Parameters/_BasePreambleParametersOrientationAll as a Component
    */
    export type BasePreambleParametersOrientationAll_Component = ComponentProps & BasePreambleParametersOrientationAll

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/Rendering Parameters/_BasePreambleParametersOrientationAll as a Route
    */
    export type BasePreambleParametersOrientationAll_Route = RouteData & BasePreambleParametersOrientationAll

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Base/Rendering Parameters/_BasePreambleParametersOrientationAll
    */
    export type BasePreambleParametersOrientationAllJson =  {
        
            /**
            * Represents the Preamble Orientation field (c1481194-412a-4dc8-a84e-a3b64c1260b6).
            */
            preambleOrientation?: {
                jsonValue: Field<string>
            };


    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/Rendering Parameters/_BasePreambleParametersOrientationTop
    */
    export type BasePreambleParametersOrientationTop =  {
        fields?: { 
            /**
            * Represents the Preamble Orientation field (b6fddfe3-0e4d-49d2-b46f-f8a43030108a).
            */
            preambleOrientation?: Field<string>;
        }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/Rendering Parameters/_BasePreambleParametersOrientationTop as an Item
    */
    export type BasePreambleParametersOrientationTop_Item = Omit<Item, 'fields'> & BasePreambleParametersOrientationTop

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/Rendering Parameters/_BasePreambleParametersOrientationTop as a Component
    */
    export type BasePreambleParametersOrientationTop_Component = ComponentProps & BasePreambleParametersOrientationTop

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/Rendering Parameters/_BasePreambleParametersOrientationTop as a Route
    */
    export type BasePreambleParametersOrientationTop_Route = RouteData & BasePreambleParametersOrientationTop

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Base/Rendering Parameters/_BasePreambleParametersOrientationTop
    */
    export type BasePreambleParametersOrientationTopJson =  {
        
            /**
            * Represents the Preamble Orientation field (b6fddfe3-0e4d-49d2-b46f-f8a43030108a).
            */
            preambleOrientation?: {
                jsonValue: Field<string>
            };


    }
}
export namespace Data.UserProfile {

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/UserProfile/_BaseQuestions
    */
    export type BaseQuestions =  {
        fields?: { 
            /**
            * Represents the isRequired field (6b506790-e1c4-4fdf-b902-0cf16c87b8f4).
            */
            isRequired?: Field<boolean>;

            /**
            * Represents the questionId field (0d3554c1-4714-4a6b-88b3-595050bd3c73).
            */
            questionId?: Field<string>;

            /**
            * Represents the questionLabel field (98fa6d6c-076a-4da5-8b0a-ce55fdd383e9).
            */
            questionLabel?: Field<string>;

            /**
            * Represents the questionPlaceholder field (30cfbb9a-5fdd-4782-96fd-50221b1abed9).
            */
            questionPlaceholder?: Field<string>;

            /**
            * Represents the questionsDropdownList field (66a7810b-5105-4328-bb34-7e76d0b9b9a4).
            */
            questionsDropdownList?: Item[];
        }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/UserProfile/_BaseQuestions as an Item
    */
    export type BaseQuestions_Item = Omit<Item, 'fields'> & BaseQuestions

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/UserProfile/_BaseQuestions as a Component
    */
    export type BaseQuestions_Component = ComponentProps & BaseQuestions

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/UserProfile/_BaseQuestions as a Route
    */
    export type BaseQuestions_Route = RouteData & BaseQuestions

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Data/UserProfile/_BaseQuestions
    */
    export type BaseQuestionsJson =  {
        
            /**
            * Represents the isRequired field (6b506790-e1c4-4fdf-b902-0cf16c87b8f4).
            */
            isRequired?: {
                jsonValue: Field<boolean>
            };

            /**
            * Represents the questionId field (0d3554c1-4714-4a6b-88b3-595050bd3c73).
            */
            questionId?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the questionLabel field (98fa6d6c-076a-4da5-8b0a-ce55fdd383e9).
            */
            questionLabel?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the questionPlaceholder field (30cfbb9a-5fdd-4782-96fd-50221b1abed9).
            */
            questionPlaceholder?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the questionsDropdownList field (66a7810b-5105-4328-bb34-7e76d0b9b9a4).
            */
            questionsDropdownList?: {
                jsonValue: Item[]
            };


    }
}
export namespace Legacy.ContentDataSources {

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/ContentDataSources/_BaseRelatedDataSource
    */
    export type BaseRelatedDataSource =  {
        fields?: { 
            /**
            * Represents the Related Content Type field (50a4ba93-4d62-4aed-8f70-af0441aff374).
            */
            relatedContentType?: Item;
        }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/ContentDataSources/_BaseRelatedDataSource as an Item
    */
    export type BaseRelatedDataSource_Item = Omit<Item, 'fields'> & BaseRelatedDataSource

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/ContentDataSources/_BaseRelatedDataSource as a Component
    */
    export type BaseRelatedDataSource_Component = ComponentProps & BaseRelatedDataSource

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/ContentDataSources/_BaseRelatedDataSource as a Route
    */
    export type BaseRelatedDataSource_Route = RouteData & BaseRelatedDataSource

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Legacy/ContentDataSources/_BaseRelatedDataSource
    */
    export type BaseRelatedDataSourceJson =  {
        
            /**
            * Represents the Related Content Type field (50a4ba93-4d62-4aed-8f70-af0441aff374).
            */
            relatedContentType?: {
                jsonValue: Item
            };


    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/ContentDataSources/_BaseSearchDataSource
    */
    export type BaseSearchDataSource =  {
        fields?: { 
            /**
            * Represents the Search Term field (6c8c032a-c215-49ad-8231-5e272fe63a14).
            */
            searchTerm?: Field<string>;
        }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/ContentDataSources/_BaseSearchDataSource as an Item
    */
    export type BaseSearchDataSource_Item = Omit<Item, 'fields'> & BaseSearchDataSource

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/ContentDataSources/_BaseSearchDataSource as a Component
    */
    export type BaseSearchDataSource_Component = ComponentProps & BaseSearchDataSource

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/ContentDataSources/_BaseSearchDataSource as a Route
    */
    export type BaseSearchDataSource_Route = RouteData & BaseSearchDataSource

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Legacy/ContentDataSources/_BaseSearchDataSource
    */
    export type BaseSearchDataSourceJson =  {
        
            /**
            * Represents the Search Term field (6c8c032a-c215-49ad-8231-5e272fe63a14).
            */
            searchTerm?: {
                jsonValue: Field<string>
            };


    }
}
export namespace Base.RenderingParameters {

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/Rendering Parameters/_BaseThemeParameters
    */
    export type BaseThemeParameters =  {
        fields?: { 
            /**
            * Represents the Theme field (1a2fef87-0e32-4847-9f73-4d9e785bc94e).
            */
            theme?: Field<string>;
        }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/Rendering Parameters/_BaseThemeParameters as an Item
    */
    export type BaseThemeParameters_Item = Omit<Item, 'fields'> & BaseThemeParameters

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/Rendering Parameters/_BaseThemeParameters as a Component
    */
    export type BaseThemeParameters_Component = ComponentProps & BaseThemeParameters

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/Rendering Parameters/_BaseThemeParameters as a Route
    */
    export type BaseThemeParameters_Route = RouteData & BaseThemeParameters

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Base/Rendering Parameters/_BaseThemeParameters
    */
    export type BaseThemeParametersJson =  {
        
            /**
            * Represents the Theme field (1a2fef87-0e32-4847-9f73-4d9e785bc94e).
            */
            theme?: {
                jsonValue: Field<string>
            };


    }
}
export namespace Base.ComponentFields.CtaFields {

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/ComponentFields/CtaFields/_Cta1Field
    */
    export type Cta1Field =  {
        fields?: { 
            /**
            * Represents the Primary CTA field (aa78de56-3325-4159-a75f-5578d949829d).
            */
            cta1?: LinkField;
        }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/ComponentFields/CtaFields/_Cta1Field as an Item
    */
    export type Cta1Field_Item = Omit<Item, 'fields'> & Cta1Field

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/ComponentFields/CtaFields/_Cta1Field as a Component
    */
    export type Cta1Field_Component = ComponentProps & Cta1Field

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/ComponentFields/CtaFields/_Cta1Field as a Route
    */
    export type Cta1Field_Route = RouteData & Cta1Field

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Base/ComponentFields/CtaFields/_Cta1Field
    */
    export type Cta1FieldJson =  {
        
            /**
            * Represents the Primary CTA field (aa78de56-3325-4159-a75f-5578d949829d).
            */
            cta1?: {
                jsonValue: LinkField
            };


    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/ComponentFields/CtaFields/_Cta2Field
    */
    export type Cta2Field =  {
        fields?: { 
            /**
            * Represents the Secondary CTA field (ffc9d8fb-bd9e-45eb-a97c-80536663c080).
            */
            cta2?: LinkField;
        }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/ComponentFields/CtaFields/_Cta2Field as an Item
    */
    export type Cta2Field_Item = Omit<Item, 'fields'> & Cta2Field

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/ComponentFields/CtaFields/_Cta2Field as a Component
    */
    export type Cta2Field_Component = ComponentProps & Cta2Field

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/ComponentFields/CtaFields/_Cta2Field as a Route
    */
    export type Cta2Field_Route = RouteData & Cta2Field

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Base/ComponentFields/CtaFields/_Cta2Field
    */
    export type Cta2FieldJson =  {
        
            /**
            * Represents the Secondary CTA field (ffc9d8fb-bd9e-45eb-a97c-80536663c080).
            */
            cta2?: {
                jsonValue: LinkField
            };


    }
}
export namespace Legacy.ContentDataSources {

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/ContentDataSources/_FilterableDataSource
    */
    export type FilterableDataSource =  {
        fields?: { 
            /**
            * Represents the Content Type field (ac269256-0a97-4e1d-870a-672cf5c679a6).
            */
            contentType?: Field<string>;

            /**
            * Represents the Property Filters field (86f6043e-f5c2-4b93-9338-6b33e0f510fe).
            */
            propertyFilters?: Item[];
        }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/ContentDataSources/_FilterableDataSource as an Item
    */
    export type FilterableDataSource_Item = Omit<Item, 'fields'> & FilterableDataSource

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/ContentDataSources/_FilterableDataSource as a Component
    */
    export type FilterableDataSource_Component = ComponentProps & FilterableDataSource

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/ContentDataSources/_FilterableDataSource as a Route
    */
    export type FilterableDataSource_Route = RouteData & FilterableDataSource

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Legacy/ContentDataSources/_FilterableDataSource
    */
    export type FilterableDataSourceJson =  {
        
            /**
            * Represents the Content Type field (ac269256-0a97-4e1d-870a-672cf5c679a6).
            */
            contentType?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Property Filters field (86f6043e-f5c2-4b93-9338-6b33e0f510fe).
            */
            propertyFilters?: {
                jsonValue: Item[]
            };


    }
}
export namespace Base.ComponentFields.HeadlineFields {

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/ComponentFields/HeadlineFields/_HeadlineAccentsFields
    */
    export type HeadlineAccentsFields =  {
        fields?: { 
            /**
            * Represents the Headline Accent - After field (c518432b-2b85-4735-8d86-1a33663dd8e1).
            */
            headlineAccentAfter?: Field<string>;

            /**
            * Represents the Headline Accent - Before field (bdc87c45-2560-4051-a2c8-58b6ff98e55e).
            */
            headlineAccentBefore?: Field<string>;
        }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/ComponentFields/HeadlineFields/_HeadlineAccentsFields as an Item
    */
    export type HeadlineAccentsFields_Item = Omit<Item, 'fields'> & HeadlineAccentsFields

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/ComponentFields/HeadlineFields/_HeadlineAccentsFields as a Component
    */
    export type HeadlineAccentsFields_Component = ComponentProps & HeadlineAccentsFields

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/ComponentFields/HeadlineFields/_HeadlineAccentsFields as a Route
    */
    export type HeadlineAccentsFields_Route = RouteData & HeadlineAccentsFields

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Base/ComponentFields/HeadlineFields/_HeadlineAccentsFields
    */
    export type HeadlineAccentsFieldsJson =  {
        
            /**
            * Represents the Headline Accent - After field (c518432b-2b85-4735-8d86-1a33663dd8e1).
            */
            headlineAccentAfter?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Headline Accent - Before field (bdc87c45-2560-4051-a2c8-58b6ff98e55e).
            */
            headlineAccentBefore?: {
                jsonValue: Field<string>
            };


    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/ComponentFields/HeadlineFields/_HeadlineDescriptionField
    */
    export type HeadlineDescriptionField =  {
        fields?: { 
            /**
            * Represents the Description field (57adec0f-c47d-41bc-a443-c93c3ce64598).
            */
            headlineDescription?: Field<string>;
        }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/ComponentFields/HeadlineFields/_HeadlineDescriptionField as an Item
    */
    export type HeadlineDescriptionField_Item = Omit<Item, 'fields'> & HeadlineDescriptionField

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/ComponentFields/HeadlineFields/_HeadlineDescriptionField as a Component
    */
    export type HeadlineDescriptionField_Component = ComponentProps & HeadlineDescriptionField

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/ComponentFields/HeadlineFields/_HeadlineDescriptionField as a Route
    */
    export type HeadlineDescriptionField_Route = RouteData & HeadlineDescriptionField

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Base/ComponentFields/HeadlineFields/_HeadlineDescriptionField
    */
    export type HeadlineDescriptionFieldJson =  {
        
            /**
            * Represents the Description field (57adec0f-c47d-41bc-a443-c93c3ce64598).
            */
            headlineDescription?: {
                jsonValue: Field<string>
            };


    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/ComponentFields/HeadlineFields/_HeadlineEyebrowField
    */
    export type HeadlineEyebrowField =  {
        fields?: { 
            /**
            * Represents the Eyebrow field (1dd4d309-98f9-4dc0-9ea9-c63379e38d60).
            */
            headlineEyebrow?: Field<string>;
        }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/ComponentFields/HeadlineFields/_HeadlineEyebrowField as an Item
    */
    export type HeadlineEyebrowField_Item = Omit<Item, 'fields'> & HeadlineEyebrowField

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/ComponentFields/HeadlineFields/_HeadlineEyebrowField as a Component
    */
    export type HeadlineEyebrowField_Component = ComponentProps & HeadlineEyebrowField

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/ComponentFields/HeadlineFields/_HeadlineEyebrowField as a Route
    */
    export type HeadlineEyebrowField_Route = RouteData & HeadlineEyebrowField

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Base/ComponentFields/HeadlineFields/_HeadlineEyebrowField
    */
    export type HeadlineEyebrowFieldJson =  {
        
            /**
            * Represents the Eyebrow field (1dd4d309-98f9-4dc0-9ea9-c63379e38d60).
            */
            headlineEyebrow?: {
                jsonValue: Field<string>
            };


    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/ComponentFields/HeadlineFields/_HeadlineField
    */
    export type HeadlineField =  {
        fields?: { 
            /**
            * Represents the Headline field (d451cbe8-e040-40a7-9496-7e510cc64af4).
            */
            headline?: Field<string>;
        }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/ComponentFields/HeadlineFields/_HeadlineField as an Item
    */
    export type HeadlineField_Item = Omit<Item, 'fields'> & HeadlineField

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/ComponentFields/HeadlineFields/_HeadlineField as a Component
    */
    export type HeadlineField_Component = ComponentProps & HeadlineField

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/ComponentFields/HeadlineFields/_HeadlineField as a Route
    */
    export type HeadlineField_Route = RouteData & HeadlineField

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Base/ComponentFields/HeadlineFields/_HeadlineField
    */
    export type HeadlineFieldJson =  {
        
            /**
            * Represents the Headline field (d451cbe8-e040-40a7-9496-7e510cc64af4).
            */
            headline?: {
                jsonValue: Field<string>
            };


    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/ComponentFields/HeadlineFields/_HeadlineIconField
    */
    export type HeadlineIconField =  {
        fields?: { 
            /**
            * Represents the Icon field (36ef1f32-4598-4aca-b205-3aa85a262c6e).
            */
            headlineIcon?: ImageField;
        }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/ComponentFields/HeadlineFields/_HeadlineIconField as an Item
    */
    export type HeadlineIconField_Item = Omit<Item, 'fields'> & HeadlineIconField

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/ComponentFields/HeadlineFields/_HeadlineIconField as a Component
    */
    export type HeadlineIconField_Component = ComponentProps & HeadlineIconField

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/ComponentFields/HeadlineFields/_HeadlineIconField as a Route
    */
    export type HeadlineIconField_Route = RouteData & HeadlineIconField

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Base/ComponentFields/HeadlineFields/_HeadlineIconField
    */
    export type HeadlineIconFieldJson =  {
        
            /**
            * Represents the Icon field (36ef1f32-4598-4aca-b205-3aa85a262c6e).
            */
            headlineIcon?: {
                jsonValue: ImageField
            };


    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/ComponentFields/HeadlineFields/_HeadlineSubheadField
    */
    export type HeadlineSubheadField =  {
        fields?: { 
            /**
            * Represents the Subhead field (89f22601-330e-4923-903c-348f2a2a3c26).
            */
            headlineSubhead?: Field<string>;
        }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/ComponentFields/HeadlineFields/_HeadlineSubheadField as an Item
    */
    export type HeadlineSubheadField_Item = Omit<Item, 'fields'> & HeadlineSubheadField

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/ComponentFields/HeadlineFields/_HeadlineSubheadField as a Component
    */
    export type HeadlineSubheadField_Component = ComponentProps & HeadlineSubheadField

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/ComponentFields/HeadlineFields/_HeadlineSubheadField as a Route
    */
    export type HeadlineSubheadField_Route = RouteData & HeadlineSubheadField

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Base/ComponentFields/HeadlineFields/_HeadlineSubheadField
    */
    export type HeadlineSubheadFieldJson =  {
        
            /**
            * Represents the Subhead field (89f22601-330e-4923-903c-348f2a2a3c26).
            */
            headlineSubhead?: {
                jsonValue: Field<string>
            };


    }
}
export namespace Data.UserProfile {

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/UserProfile/_MyAccountLinkType
    */
    export type MyAccountLinkType =  {
        fields?: { 
            /**
            * Represents the My Account Link Type field (6926bf6b-d5ec-4d63-a650-7947a90e97e3).
            */
            linkType?: Item;

            /**
            * Represents the Title field (d394beef-1570-415e-a2fd-fe3eaca1eb74).
            */
            title?: Field<string>;
        }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/UserProfile/_MyAccountLinkType as an Item
    */
    export type MyAccountLinkType_Item = Omit<Item, 'fields'> & MyAccountLinkType

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/UserProfile/_MyAccountLinkType as a Component
    */
    export type MyAccountLinkType_Component = ComponentProps & MyAccountLinkType

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/UserProfile/_MyAccountLinkType as a Route
    */
    export type MyAccountLinkType_Route = RouteData & MyAccountLinkType

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Data/UserProfile/_MyAccountLinkType
    */
    export type MyAccountLinkTypeJson =  {
        
            /**
            * Represents the My Account Link Type field (6926bf6b-d5ec-4d63-a650-7947a90e97e3).
            */
            linkType?: {
                jsonValue: Item
            };

            /**
            * Represents the Title field (d394beef-1570-415e-a2fd-fe3eaca1eb74).
            */
            title?: {
                jsonValue: Field<string>
            };


    }
}
export namespace Base.PageFields {

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/PageFields/_PageDetails
    */
    export type PageDetails =  {
        fields?: { 
            /**
            * Represents the Constrained Page Width field (07d23639-195f-4185-bf94-fef840513918).
            */
            constrainedPageWidth?: Field<boolean>;

            /**
            * Represents the Content Type field (7d12c499-646c-402d-b1be-4211ee92705b).
            */
            contentType?: Field<string>;

            /**
            * Represents the GMI Meta Tags field (6f7efb5f-ad9c-44d3-a2cb-a3b3fc6bd977).
            */
            metadataTags?: Field<string>;

            /**
            * Represents the Publication Date field (d8a36c8c-dd63-4692-8450-33066f7dd6de).
            */
            publicationDate?: TextField;

            /**
            * Represents the SEO Modified Date field (1b79d0c4-f8ef-4c56-a831-ea60dced31c4).
            */
            seoModifiedDate?: TextField;
        }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/PageFields/_PageDetails as an Item
    */
    export type PageDetails_Item = Omit<Item, 'fields'> & PageDetails

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/PageFields/_PageDetails as a Component
    */
    export type PageDetails_Component = ComponentProps & PageDetails

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/PageFields/_PageDetails as a Route
    */
    export type PageDetails_Route = RouteData & PageDetails

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Base/PageFields/_PageDetails
    */
    export type PageDetailsJson =  {
        
            /**
            * Represents the Constrained Page Width field (07d23639-195f-4185-bf94-fef840513918).
            */
            constrainedPageWidth?: {
                jsonValue: Field<boolean>
            };

            /**
            * Represents the Content Type field (7d12c499-646c-402d-b1be-4211ee92705b).
            */
            contentType?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the GMI Meta Tags field (6f7efb5f-ad9c-44d3-a2cb-a3b3fc6bd977).
            */
            metadataTags?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Publication Date field (d8a36c8c-dd63-4692-8450-33066f7dd6de).
            */
            publicationDate?: {
                jsonValue: TextField
            };

            /**
            * Represents the SEO Modified Date field (1b79d0c4-f8ef-4c56-a831-ea60dced31c4).
            */
            seoModifiedDate?: {
                jsonValue: TextField
            };


    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/PageFields/_PageTechnicalDetails
    */
    export type PageTechnicalDetails =  {
        fields?: { 
            /**
            * Represents the Base Content ID field (aea4c76b-f90c-4769-a101-174c65cb6adf).
            */
            baseContentId?: Field<string>;

            /**
            * Represents the Exclude From Seed Page field (aaf54866-59a8-4acc-8443-099b4958d182).
            */
            excludeFromSeedPage?: Field<boolean>;
        }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/PageFields/_PageTechnicalDetails as an Item
    */
    export type PageTechnicalDetails_Item = Omit<Item, 'fields'> & PageTechnicalDetails

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/PageFields/_PageTechnicalDetails as a Component
    */
    export type PageTechnicalDetails_Component = ComponentProps & PageTechnicalDetails

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/PageFields/_PageTechnicalDetails as a Route
    */
    export type PageTechnicalDetails_Route = RouteData & PageTechnicalDetails

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Base/PageFields/_PageTechnicalDetails
    */
    export type PageTechnicalDetailsJson =  {
        
            /**
            * Represents the Base Content ID field (aea4c76b-f90c-4769-a101-174c65cb6adf).
            */
            baseContentId?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Exclude From Seed Page field (aaf54866-59a8-4acc-8443-099b4958d182).
            */
            excludeFromSeedPage?: {
                jsonValue: Field<boolean>
            };


    }
}
export namespace Data.UserProfile {

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/UserProfile/_SocialConnect
    */
    export type SocialConnect =  {
        fields?: { 
            /**
            * Represents the Already A Member Description field (82652c80-40ff-4e1d-9300-4ec16c5084e5).
            */
            alreadyMemberDescription?: Field<string>;

            /**
            * Represents the Already A Member Heading field (a3f49d1c-f7dc-410f-a34a-13e83722b350).
            */
            alreadyMemberHeading?: Field<string>;

            /**
            * Represents the Already A Member Cancel Link field (f24d5952-d3d7-4808-978d-6fd8db110262).
            */
            cancelCTA?: LinkField;

            /**
            * Represents the Already A Member Submit Text field (07ea3eb8-1086-49ec-a909-35108dc63c0f).
            */
            socialConnectSubmitText?: Field<string>;

            /**
            * Represents the Verify Email Input Label field (0be0d0d6-45be-4d4c-b882-1fc9a05214cc).
            */
            verifyEmailLabel?: Field<string>;

            /**
            * Represents the Verify Email Input Placeholder field (277ba5b8-c08b-47de-86a2-ccda95e4225c).
            */
            verifyEmailPlaceholder?: Field<string>;
        }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/UserProfile/_SocialConnect as an Item
    */
    export type SocialConnect_Item = Omit<Item, 'fields'> & SocialConnect

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/UserProfile/_SocialConnect as a Component
    */
    export type SocialConnect_Component = ComponentProps & SocialConnect

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Data/UserProfile/_SocialConnect as a Route
    */
    export type SocialConnect_Route = RouteData & SocialConnect

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Data/UserProfile/_SocialConnect
    */
    export type SocialConnectJson =  {
        
            /**
            * Represents the Already A Member Description field (82652c80-40ff-4e1d-9300-4ec16c5084e5).
            */
            alreadyMemberDescription?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Already A Member Heading field (a3f49d1c-f7dc-410f-a34a-13e83722b350).
            */
            alreadyMemberHeading?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Already A Member Cancel Link field (f24d5952-d3d7-4808-978d-6fd8db110262).
            */
            cancelCTA?: {
                jsonValue: LinkField
            };

            /**
            * Represents the Already A Member Submit Text field (07ea3eb8-1086-49ec-a909-35108dc63c0f).
            */
            socialConnectSubmitText?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Verify Email Input Label field (0be0d0d6-45be-4d4c-b882-1fc9a05214cc).
            */
            verifyEmailLabel?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Verify Email Input Placeholder field (277ba5b8-c08b-47de-86a2-ccda95e4225c).
            */
            verifyEmailPlaceholder?: {
                jsonValue: Field<string>
            };


    }
}
export namespace Legacy.ContentDataSources {

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/ContentDataSources/_SortableDataSource
    */
    export type SortableDataSource =  {
        fields?: { 
            /**
            * Represents the Default Sort By field (46607fd5-f352-4039-a439-179bdba66fef).
            */
            defaultSortBy?: Field<string>;

            /**
            * Represents the Default Sort Direction field (3506a246-ef5a-42eb-9858-2f7c6c09c029).
            */
            defaultSortDirection?: Field<string>;
        }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/ContentDataSources/_SortableDataSource as an Item
    */
    export type SortableDataSource_Item = Omit<Item, 'fields'> & SortableDataSource

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/ContentDataSources/_SortableDataSource as a Component
    */
    export type SortableDataSource_Component = ComponentProps & SortableDataSource

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Legacy/ContentDataSources/_SortableDataSource as a Route
    */
    export type SortableDataSource_Route = RouteData & SortableDataSource

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Legacy/ContentDataSources/_SortableDataSource
    */
    export type SortableDataSourceJson =  {
        
            /**
            * Represents the Default Sort By field (46607fd5-f352-4039-a439-179bdba66fef).
            */
            defaultSortBy?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Default Sort Direction field (3506a246-ef5a-42eb-9858-2f7c6c09c029).
            */
            defaultSortDirection?: {
                jsonValue: Field<string>
            };


    }
}
export namespace Base.PageFields {

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/PageFields/_pageComponents
    */
    export type pageComponents =  {
        fields?: { 
            /**
            * Represents the Disable Hero Action Toolbar field (395f6e55-303a-45d5-8935-fb49c6869bec).
            */
            disableHeroActionToolbar?: Field<boolean>;

            /**
            * Represents the Hide newsletter component (Check this to hide) field (92c16036-e7ef-4370-af1c-b23f2f630912).
            */
            hideNewsletterSignupBanner?: Field<boolean>;

            /**
            * Represents the Hide Newsletter Signup Modal field (9348573e-1572-4053-ad77-bd33f4ca7c2d).
            */
            hideNewsletterSignupModal?: Field<boolean>;
        }

    }

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/PageFields/_pageComponents as an Item
    */
    export type pageComponents_Item = Omit<Item, 'fields'> & pageComponents

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/PageFields/_pageComponents as a Component
    */
    export type pageComponents_Component = ComponentProps & pageComponents

    /**
    * Represents the template /sitecore/templates/Foundation/GMI/Base/PageFields/_pageComponents as a Route
    */
    export type pageComponents_Route = RouteData & pageComponents

    /**
    * Represents the GraphQL template /sitecore/templates/Foundation/GMI/Base/PageFields/_pageComponents
    */
    export type pageComponentsJson =  {
        
            /**
            * Represents the Disable Hero Action Toolbar field (395f6e55-303a-45d5-8935-fb49c6869bec).
            */
            disableHeroActionToolbar?: {
                jsonValue: Field<boolean>
            };

            /**
            * Represents the Hide newsletter component (Check this to hide) field (92c16036-e7ef-4370-af1c-b23f2f630912).
            */
            hideNewsletterSignupBanner?: {
                jsonValue: Field<boolean>
            };

            /**
            * Represents the Hide Newsletter Signup Modal field (9348573e-1572-4053-ad77-bd33f4ca7c2d).
            */
            hideNewsletterSignupModal?: {
                jsonValue: Field<boolean>
            };


    }
}




/**
 * <auto-generated>
 *     This code was generated by a tool.
 *
 *     Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
 * </auto-generated>
 */ 

export namespace CloneableRenderings.RenderingParameters.Constants {

    export const AccordionParameters = {
        TemplateId: "c437316f-7ac6-4b27-af7a-1754892380b1",
    
        BaseTemplateIds: [
            "66e5a610-2620-4122-86ae-e48bd9e4515d", 
            "ef3ad62b-7e08-4206-809d-9c48f7257bc4", 
        ]
    }
}
export namespace Data.Content.Constants {

    export const ActionToolBarButton = {
        TemplateId: "54d7565f-b6c1-4d78-be3c-d233982d38a0",
    
        BaseTemplateIds: [
        ]
    }
    export const ActionToolBarButtonsFolder = {
        TemplateId: "de24fa2b-34c9-42eb-93d9-7d4b67cdd857",
    
        BaseTemplateIds: [
        ]
    }
}
export namespace Data.Settings.Constants {

    export const AlertBannerSettings = {
        TemplateId: "38577dfb-9832-4087-9226-87a1dc02396e",
    
        BaseTemplateIds: [
        ]
    }
    export const ArticleSettings = {
        TemplateId: "2ae31d46-e3eb-4beb-95f6-48150e437358",
    
        BaseTemplateIds: [
        ]
    }
}
export namespace Data.Contributor.Constants {

    export const AuthorContributor = {
        TemplateId: "60d88d75-078f-43ac-929b-1c797bf233ed",
    
        BaseTemplateIds: [
        ]
    }
    export const AuthorsTypeFolder = {
        TemplateId: "14d6e31e-9fea-484a-aae1-75158819f835",
    
        BaseTemplateIds: [
        ]
    }
}
export namespace Data.Settings.Constants {

    export const BadgeSettings = {
        TemplateId: "bd8b7544-97ff-4aac-8957-c8071a3d641c",
    
        BaseTemplateIds: [
        ]
    }
    export const BazaarVoiceSettings = {
        TemplateId: "85a5869e-d3b1-4015-9470-16514a1b831f",
    
        BaseTemplateIds: [
        ]
    }
    export const BuyNowSettings = {
        TemplateId: "75047f9d-deb0-477d-ace5-fdb0db79b2ff",
    
        BaseTemplateIds: [
        ]
    }
}
export namespace Data.Cards.Constants {

    export const CardDetailLevel = {
        TemplateId: "7ecc3d03-65dc-4168-89b5-703a0c259d61",
    
        BaseTemplateIds: [
            "50891a88-a6a5-4e00-ba5f-6460de6e9bd1", 
        ]
    }
    export const CardDetailLevelFolder = {
        TemplateId: "1038f3ea-6675-426c-af6b-3043c67f66f5",
    
        BaseTemplateIds: [
        ]
    }
}
export namespace Data.Content.Constants {

    export const Claims = {
        TemplateId: "d1ee78dc-ad4d-4f9b-b80e-fb236e5bd8d5",
    
        BaseTemplateIds: [
        ]
    }
}
export namespace CloneableRenderings.Constants {

    export const ComponentWithDatasource = {
        TemplateId: "8bccf136-92d3-48f5-82e8-7a1650fc37c8",
    
        BaseTemplateIds: [
            "ce3bc42c-cb36-4866-9bce-2db5f1e31223", 
        ]
    }
    export const ComponentWithDatasourceFolder = {
        TemplateId: "88897427-e9d9-49c3-aa07-64ad46c76b2c",
    
        BaseTemplateIds: [
        ]
    }
}
export namespace CloneableRenderings.RenderingParameters.Constants {

    export const ComponentWithDatasourceParameters = {
        TemplateId: "66e5a610-2620-4122-86ae-e48bd9e4515d",
    
        BaseTemplateIds: [
            "ef3ad62b-7e08-4206-809d-9c48f7257bc4", 
        ]
    }
}
export namespace CloneableRenderings.Constants {

    export const ComponentWithoutDatasource = {
        TemplateId: "cd1b943b-0bd8-4846-84b6-e5e0a0ec8602",
    
        BaseTemplateIds: [
            "ce3bc42c-cb36-4866-9bce-2db5f1e31223", 
        ]
    }
    export const ComponentWithoutDatasourceFolder = {
        TemplateId: "28c05674-909c-41d4-b93e-039764279a85",
    
        BaseTemplateIds: [
        ]
    }
}
export namespace CloneableRenderings.RenderingParameters.Constants {

    export const ComponentWithoutDatasourceParameters = {
        TemplateId: "457130c3-2ca5-496b-b63e-261639fcc8a4",
    
        BaseTemplateIds: [
            "ef3ad62b-7e08-4206-809d-9c48f7257bc4", 
        ]
    }
}
export namespace Data.Settings.Constants {

    export const ContentGridImageOverride = {
        TemplateId: "cb48cd23-f2d3-4e52-a9b8-f9e022f47086",
    
        BaseTemplateIds: [
        ]
    }
    export const ContentGridSettings = {
        TemplateId: "28d4b596-baf5-48b9-a197-cb393a8ebc45",
    
        BaseTemplateIds: [
        ]
    }
}
export namespace Legacy.SearchNx.Constants {

    export const ContentOverride = {
        TemplateId: "7f22d289-c802-448b-8997-0f71f81ea6f3",
    
        BaseTemplateIds: [
            "50891a88-a6a5-4e00-ba5f-6460de6e9bd1", 
        ]
    }
}
export namespace Legacy.ContentDataSources.Constants {

    export const ContentDataSourceBase = {
        TemplateId: "c0df3346-6afb-4525-b186-3f8de7568d2b",
    
        BaseTemplateIds: [
            "50891a88-a6a5-4e00-ba5f-6460de6e9bd1", 
        ]
    }
}
export namespace Legacy.SearchNx.Constants {

    export const ContentListDataFolder = {
        TemplateId: "75779e0d-7685-479a-b94d-e75abf95ea8c",
    
        BaseTemplateIds: [
        ]
    }
}
export namespace Data.Content.Constants {

    export const ContentType = {
        TemplateId: "649cc288-5211-46fb-9525-479b45a522d2",
    
        BaseTemplateIds: [
            "50891a88-a6a5-4e00-ba5f-6460de6e9bd1", 
        ]
    }
    export const ContentTypeFolder = {
        TemplateId: "1bdb4903-effd-4d13-b3e0-f8ce08e38aa7",
    
        BaseTemplateIds: [
        ]
    }
}
export namespace Legacy.ContentDataSources.Constants {

    export const CuratedContentDataSource = {
        TemplateId: "25d9ace5-61e6-4b02-939b-f91bf9a5621a",
    
        BaseTemplateIds: [
            "c0df3346-6afb-4525-b186-3f8de7568d2b", 
            "50891a88-a6a5-4e00-ba5f-6460de6e9bd1", 
        ]
    }
}
export namespace Data.Settings.Constants {

    export const DisableFeatureSettings = {
        TemplateId: "5bcbc8c6-a1f8-490d-a658-dcc61db9c951",
    
        BaseTemplateIds: [
            "50891a88-a6a5-4e00-ba5f-6460de6e9bd1", 
        ]
    }
}
export namespace Legacy.ContentDataSources.Constants {

    export const DynamicContentDataSource = {
        TemplateId: "1023013e-f6a7-4049-9c8d-7a169cca7db8",
    
        BaseTemplateIds: [
            "c0df3346-6afb-4525-b186-3f8de7568d2b", 
            "50891a88-a6a5-4e00-ba5f-6460de6e9bd1", 
            "b317f626-b229-4bd8-b114-d70bd39ec0cf", 
            "d042be2f-0be9-462c-9f5d-32b5773d15dc", 
            "7724b128-9fc5-4ead-9e1b-d2e7e941ef2c", 
            "bfd32a35-1ede-4548-b993-2a43fdeb99ad", 
            "571ca0ff-a05b-4b4f-a998-5dfb29d3af55", 
        ]
    }
}
export namespace Data.Settings.Constants {

    export const EmailSettings = {
        TemplateId: "67105104-fb8e-4529-ac3b-e466f5563963",
    
        BaseTemplateIds: [
            "50891a88-a6a5-4e00-ba5f-6460de6e9bd1", 
        ]
    }
}
export namespace Data.Enums.Constants {

    export const EnumFolder = {
        TemplateId: "781d39ed-7ee4-480f-a2c6-2579510cfe4c",
    
        BaseTemplateIds: [
        ]
    }
    export const EnumBasic = {
        TemplateId: "efe813c4-e1eb-4baf-beb5-b7d7236c5578",
    
        BaseTemplateIds: [
            "50891a88-a6a5-4e00-ba5f-6460de6e9bd1", 
        ]
    }
    export const Gmienum = {
        TemplateId: "626997bb-fc2a-4588-8e5b-17ac2a840706",
    
        BaseTemplateIds: [
            "50891a88-a6a5-4e00-ba5f-6460de6e9bd1", 
        ]
    }
}
export namespace Data.Links.Constants {

    export const GenericLink = {
        TemplateId: "b7e9466d-8242-4efc-a137-c21c9e181ecb",
    
        BaseTemplateIds: [
            "50891a88-a6a5-4e00-ba5f-6460de6e9bd1", 
        ]
    }
}
export namespace Data.GlobalData.Constants {

    export const GlobalFolder = {
        TemplateId: "1f14ced2-7051-4f4e-9f2c-6a06d28f72f9",
    
        BaseTemplateIds: [
        ]
    }
}
export namespace Data.Settings.Constants {

    export const HeaderSettings = {
        TemplateId: "dd246ec9-a553-461a-afb2-8d6ec91fd42a",
    
        BaseTemplateIds: [
        ]
    }
    export const LoginAndRegistrationSettings = {
        TemplateId: "352010b9-03e0-40e9-90d1-ff7cd533b529",
    
        BaseTemplateIds: [
        ]
    }
}
export namespace Legacy.ContentDataSources.Constants {

    export const MetaDataContentDataSource = {
        TemplateId: "7148f68f-a022-4d92-bf46-bd2d85412a94",
    
        BaseTemplateIds: [
            "c0df3346-6afb-4525-b186-3f8de7568d2b", 
            "50891a88-a6a5-4e00-ba5f-6460de6e9bd1", 
            "b317f626-b229-4bd8-b114-d70bd39ec0cf", 
            "d042be2f-0be9-462c-9f5d-32b5773d15dc", 
            "bfd32a35-1ede-4548-b993-2a43fdeb99ad", 
        ]
    }
}
export namespace Legacy.SearchNx.Constants {

    export const MetadataSelectorExclusionSettings = {
        TemplateId: "a6c7dbbc-ce8f-4be0-a8ba-84363a82c47b",
    
        BaseTemplateIds: [
            "50891a88-a6a5-4e00-ba5f-6460de6e9bd1", 
        ]
    }
}
export namespace CloneableRenderings.RenderingParameters.Constants {

    export const PearCommerceProductParameters = {
        TemplateId: "e05484d8-d9bb-492f-a7b3-87f21fec1c53",
    
        BaseTemplateIds: [
            "457130c3-2ca5-496b-b63e-261639fcc8a4", 
            "ef3ad62b-7e08-4206-809d-9c48f7257bc4", 
        ]
    }
}
export namespace Data.Settings.Constants {

    export const ProductDetailSettings = {
        TemplateId: "7a0fd664-b4f5-4463-8e3d-852c90a35e63",
    
        BaseTemplateIds: [
        ]
    }
}
export namespace Legacy.SearchNx.Constants {

    export const PropertyFilter = {
        TemplateId: "a3e29f7c-c072-42b9-b72b-f887eea6dc77",
    
        BaseTemplateIds: [
        ]
    }
    export const PropertyFilterFolder = {
        TemplateId: "28e7d87e-b1fd-4818-9c61-b9993514bc9a",
    
        BaseTemplateIds: [
        ]
    }
}
export namespace Data.UserProfile.QuestionsInfo.Constants {

    export const QuestionsInfo = {
        TemplateId: "008182fb-9613-46f2-83e3-76774fbc1dc0",
    
        BaseTemplateIds: [
        ]
    }
}
export namespace Data.Settings.Constants {

    export const RecipeDetailSiteSettings = {
        TemplateId: "2f791b2f-203f-4dd2-bf22-6e6fad5aa5fb",
    
        BaseTemplateIds: [
        ]
    }
}
export namespace Legacy.ContentDataSources.Constants {

    export const RelatedContentDataSource = {
        TemplateId: "819184a4-0bf5-4ac4-a55f-0f061663d192",
    
        BaseTemplateIds: [
            "c0df3346-6afb-4525-b186-3f8de7568d2b", 
            "50891a88-a6a5-4e00-ba5f-6460de6e9bd1", 
            "b317f626-b229-4bd8-b114-d70bd39ec0cf", 
            "d042be2f-0be9-462c-9f5d-32b5773d15dc", 
            "7724b128-9fc5-4ead-9e1b-d2e7e941ef2c", 
        ]
    }
}
export namespace Legacy.SearchNx.Constants {

    export const SearchConfiguration = {
        TemplateId: "a472da2d-94aa-4865-8814-d661a3c0cfd6",
    
        BaseTemplateIds: [
        ]
    }
}
export namespace Legacy.ContentDataSources.Constants {

    export const SearchContentDataSource = {
        TemplateId: "616db7d7-a1d7-4f33-b851-27c12ad00c48",
    
        BaseTemplateIds: [
            "c0df3346-6afb-4525-b186-3f8de7568d2b", 
            "50891a88-a6a5-4e00-ba5f-6460de6e9bd1", 
            "b317f626-b229-4bd8-b114-d70bd39ec0cf", 
            "d042be2f-0be9-462c-9f5d-32b5773d15dc", 
            "571ca0ff-a05b-4b4f-a998-5dfb29d3af55", 
        ]
    }
}
export namespace Data.Settings.Constants {

    export const SeoSettings = {
        TemplateId: "7b10ba19-3d06-4e32-b1ce-378c549899d0",
    
        BaseTemplateIds: [
        ]
    }
}
export namespace Data.Content.Constants {

    export const ShareActionToolBarButton = {
        TemplateId: "e2b0af1c-d8ce-48b0-aac6-e026277fecb1",
    
        BaseTemplateIds: [
            "54d7565f-b6c1-4d78-be3c-d233982d38a0", 
        ]
    }
}
export namespace Site.Constants {

    export const SiteDomain = {
        TemplateId: "a1e6494d-de2e-4e58-9d49-27b4434d8583",
    
        BaseTemplateIds: [
            "50891a88-a6a5-4e00-ba5f-6460de6e9bd1", 
        ]
    }
}
export namespace Data.Settings.Constants {

    export const SiteSettings = {
        TemplateId: "f6950030-ae2f-471f-ac34-d8f90a51ac33",
    
        BaseTemplateIds: [
            "50891a88-a6a5-4e00-ba5f-6460de6e9bd1", 
        ]
    }
}

export namespace Legacy.SearchNx.Constants {

    export const TimedReleaseOverride = {
        TemplateId: "814ef89b-77cf-4942-b262-ca773adb79df",
    
        BaseTemplateIds: [
        ]
    }
}
export namespace Data.Content.Constants {

    export const Video = {
        TemplateId: "95fcb543-849c-4701-a9ba-9950fd6c5656",
    
        BaseTemplateIds: [
        ]
    }
    export const VideoFolder = {
        TemplateId: "23f38683-c4b4-4595-b7c4-790c40d2418c",
    
        BaseTemplateIds: [
        ]
    }
}
export namespace Base.Constants {

    export const BaseComponent = {
        TemplateId: "ce3bc42c-cb36-4866-9bce-2db5f1e31223",
    
        BaseTemplateIds: [
        ]
    }
}
export namespace Base.RenderingParameters.Constants {

    export const BaseComponentLayout = {
        TemplateId: "adbad393-5562-48f2-8018-c0b53ecd5b76",
    
        BaseTemplateIds: [
        ]
    }
    export const BaseComponentParameters = {
        TemplateId: "ef3ad62b-7e08-4206-809d-9c48f7257bc4",
    
        BaseTemplateIds: [
        ]
    }
}
export namespace Base.PageFields.Constants {

    export const BaseContent = {
        TemplateId: "4c8619a1-f7cf-422b-a201-a3438db386ae",
    
        BaseTemplateIds: [
        ]
    }
}
export namespace Base.Constants {

    export const BaseData = {
        TemplateId: "50891a88-a6a5-4e00-ba5f-6460de6e9bd1",
    
        BaseTemplateIds: [
        ]
    }
}
export namespace Base.RenderingParameters.Constants {

    export const BaseGridCardParameters = {
        TemplateId: "a7b89f61-6646-42d4-bbdb-19795c13ddc8",
    
        BaseTemplateIds: [
        ]
    }
    export const BaseGridParameters = {
        TemplateId: "86f45ea0-c79d-4802-93d3-5c1e7e0e228a",
    
        BaseTemplateIds: [
        ]
    }
}
export namespace Base.ComponentFields.Combos.Constants {

    export const BaseHeadlineBasic = {
        TemplateId: "f520e796-4349-4238-b7c4-1c08d90eba70",
    
        BaseTemplateIds: [
            "60c552d6-da49-4b6b-87f3-f87e4e57a3f5", 
        ]
    }
    export const BaseHeadlineStandard = {
        TemplateId: "5423ef7a-58e9-4b08-a68e-338f55240f20",
    
        BaseTemplateIds: [
            "60c552d6-da49-4b6b-87f3-f87e4e57a3f5", 
            "01bf3399-d165-4aaf-aa91-8f6d76df1ac5", 
            "f807bf12-2ca2-4a73-a991-bcb27140da05", 
        ]
    }
}
export namespace Legacy.ContentDataSources.Constants {

    export const BaseMetaDataSource = {
        TemplateId: "bfd32a35-1ede-4548-b993-2a43fdeb99ad",
    
        BaseTemplateIds: [
        ]
    }
}
export namespace Base.Constants {

    export const BasePage = {
        TemplateId: "33a35de8-5057-4992-b209-50e19fe0b5fa",
    
        BaseTemplateIds: [
            "4c8619a1-f7cf-422b-a201-a3438db386ae", 
            "115002cf-5dbb-4e02-a646-0bd5c8a935ee", 
            "9fbd583f-95dd-4db7-bd61-7dc6925d95c9", 
            "e1a343c6-72ef-4a58-8d25-97f18a4453e1", 
        ]
    }
}
export namespace Data.UserProfile.Constants {

    export const BasePassword = {
        TemplateId: "ca72e3c2-b510-4154-a671-57e3eddba505",
    
        BaseTemplateIds: [
        ]
    }
}
export namespace Base.ComponentFields.Constants {

    export const BasePreamble = {
        TemplateId: "af41b5d7-7513-4cd8-93c6-c5499d3fc688",
    
        BaseTemplateIds: [
            "5423ef7a-58e9-4b08-a68e-338f55240f20", 
            "60c552d6-da49-4b6b-87f3-f87e4e57a3f5", 
            "01bf3399-d165-4aaf-aa91-8f6d76df1ac5", 
            "f807bf12-2ca2-4a73-a991-bcb27140da05", 
            "c216d907-57f1-40f1-8049-dadf573efbc5", 
            "4cc04b26-568d-4faf-8ca3-3f687821e5b4", 
            "f5bf7a4e-91d7-4ff3-bb47-852c71312cae", 
            "5424632c-5ed2-49ce-a568-a28edf62c35f", 
        ]
    }
}
export namespace Base.RenderingParameters.Constants {

    export const BasePreambleParametersOrientationAll = {
        TemplateId: "35150276-62d8-4f6b-b9ae-8b6d15ab6723",
    
        BaseTemplateIds: [
        ]
    }
    export const BasePreambleParametersOrientationTop = {
        TemplateId: "b4b5dd2f-fbaa-48e4-b437-f3c3622b9a78",
    
        BaseTemplateIds: [
        ]
    }
}
export namespace Data.UserProfile.Constants {

    export const BaseQuestions = {
        TemplateId: "b0442608-e4e8-42ab-9a97-6665120cc02d",
    
        BaseTemplateIds: [
        ]
    }
}
export namespace Legacy.ContentDataSources.Constants {

    export const BaseRelatedDataSource = {
        TemplateId: "7724b128-9fc5-4ead-9e1b-d2e7e941ef2c",
    
        BaseTemplateIds: [
        ]
    }
    export const BaseSearchDataSource = {
        TemplateId: "571ca0ff-a05b-4b4f-a998-5dfb29d3af55",
    
        BaseTemplateIds: [
        ]
    }
}
export namespace Base.RenderingParameters.Constants {

    export const BaseThemeParameters = {
        TemplateId: "2d5e2037-3132-4bcf-8654-79d99111292e",
    
        BaseTemplateIds: [
        ]
    }
}
export namespace Base.ComponentFields.CtaFields.Constants {

    export const Cta1Field = {
        TemplateId: "4cc04b26-568d-4faf-8ca3-3f687821e5b4",
    
        BaseTemplateIds: [
        ]
    }
    export const Cta2Field = {
        TemplateId: "f5bf7a4e-91d7-4ff3-bb47-852c71312cae",
    
        BaseTemplateIds: [
        ]
    }
}
export namespace Legacy.ContentDataSources.Constants {

    export const FilterableDataSource = {
        TemplateId: "b317f626-b229-4bd8-b114-d70bd39ec0cf",
    
        BaseTemplateIds: [
        ]
    }
}
export namespace Base.ComponentFields.HeadlineFields.Constants {

    export const HeadlineAccentsFields = {
        TemplateId: "c79d7caa-8626-4440-8cc9-b2d2978f7c71",
    
        BaseTemplateIds: [
        ]
    }
    export const HeadlineDescriptionField = {
        TemplateId: "c216d907-57f1-40f1-8049-dadf573efbc5",
    
        BaseTemplateIds: [
        ]
    }
    export const HeadlineEyebrowField = {
        TemplateId: "01bf3399-d165-4aaf-aa91-8f6d76df1ac5",
    
        BaseTemplateIds: [
        ]
    }
    export const HeadlineField = {
        TemplateId: "60c552d6-da49-4b6b-87f3-f87e4e57a3f5",
    
        BaseTemplateIds: [
        ]
    }
    export const HeadlineIconField = {
        TemplateId: "5424632c-5ed2-49ce-a568-a28edf62c35f",
    
        BaseTemplateIds: [
        ]
    }
    export const HeadlineSubheadField = {
        TemplateId: "f807bf12-2ca2-4a73-a991-bcb27140da05",
    
        BaseTemplateIds: [
        ]
    }
}
export namespace Data.UserProfile.Constants {

    export const MyAccountLinkType = {
        TemplateId: "90830101-4b8c-499b-a9f2-9ecf0f74f4c6",
    
        BaseTemplateIds: [
        ]
    }
}
export namespace Base.PageFields.Constants {

    export const PageDetails = {
        TemplateId: "115002cf-5dbb-4e02-a646-0bd5c8a935ee",
    
        BaseTemplateIds: [
        ]
    }
    export const PageTechnicalDetails = {
        TemplateId: "9fbd583f-95dd-4db7-bd61-7dc6925d95c9",
    
        BaseTemplateIds: [
        ]
    }
}
export namespace Data.UserProfile.Constants {

    export const SocialConnect = {
        TemplateId: "5fbecbf0-d603-4467-a53e-18a4882df576",
    
        BaseTemplateIds: [
        ]
    }
}
export namespace Legacy.ContentDataSources.Constants {

    export const SortableDataSource = {
        TemplateId: "d042be2f-0be9-462c-9f5d-32b5773d15dc",
    
        BaseTemplateIds: [
        ]
    }
}
export namespace Base.PageFields.Constants {

    export const pageComponents = {
        TemplateId: "e1a343c6-72ef-4a58-8d25-97f18a4453e1",
    
        BaseTemplateIds: [
        ]
    }
}    


